var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isFba
        ? _c(
            "el-form",
            {
              staticClass: "section",
              staticStyle: { "flex-direction": "row" },
              attrs: { disabled: _vm.readonly }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    width: "64px"
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("FbaJob.ValueAddedServices")) + " "
                  )
                ]
              ),
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.addedServiceChangeHandler },
                  model: {
                    value: _vm.selectedLocalAddedService,
                    callback: function($$v) {
                      _vm.selectedLocalAddedService = $$v
                    },
                    expression: "selectedLocalAddedService"
                  }
                },
                _vm._l(_vm.localAddedService, function(item) {
                  return _c(
                    "el-checkbox",
                    {
                      key: item.code,
                      staticStyle: {
                        "margin-left": "8px",
                        "margin-right": "8px"
                      },
                      attrs: {
                        label: item.code,
                        disabled: item.code === "signHBL" && _vm.form.mblOnly
                      },
                      on: {
                        change: function(val) {
                          return _vm.singleAddedServiceChangeHandler(val, item)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                  )
                }),
                1
              ),
              _vm.isBookingNew
                ? _c(
                    "el-checkbox",
                    {
                      staticStyle: {
                        "margin-left": "8px",
                        "margin-right": "8px"
                      },
                      attrs: { no: "destinationPortService" },
                      model: {
                        value: _vm.form.destinationPortService,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destinationPortService", $$v)
                        },
                        expression: "form.destinationPortService"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.PortOfDestinationServices"))
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      !_vm.isFba
        ? _c(
            "el-form",
            {
              staticClass: "section",
              staticStyle: { "flex-direction": "row" },
              attrs: { disabled: _vm.readonly }
            },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "booking" },
                  model: {
                    value: _vm.form.booking,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "booking", $$v)
                    },
                    expression: "form.booking"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "customs" },
                  on: {
                    change: function(val) {
                      _vm.form.customsBroker = val ? _vm.form.customsBroker : 0
                      _vm.form.customsDeclarationType = val
                        ? _vm.form.customsDeclarationType
                        : -1
                    }
                  },
                  model: {
                    value: _vm.form.customs,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "customs", $$v)
                    },
                    expression: "form.customs"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")) + " ")]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "isInsure" },
                  model: {
                    value: _vm.form.insure,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "insure", $$v)
                    },
                    expression: "form.insure"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "signMBL" },
                  on: {
                    change: function($event) {
                      return _vm.pm.isMBLChange()
                    }
                  },
                  model: {
                    value: _vm.form.signMBL,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "signMBL", $$v)
                    },
                    expression: "form.signMBL"
                  }
                },
                [_vm._v("MB/L ")]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "signHBL", disabled: _vm.form.mblOnly },
                  on: {
                    change: function($event) {
                      return _vm.pm.isHBLChange()
                    }
                  },
                  model: {
                    value: _vm.form.signHBL,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "signHBL", $$v)
                    },
                    expression: "form.signHBL"
                  }
                },
                [_vm._v("HB/L ")]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "virtualHBL" },
                  on: {
                    change: function($event) {
                      return _vm.pm.virtualHblChange()
                    }
                  },
                  model: {
                    value: _vm.form.virtualHBL,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "virtualHBL", $$v)
                    },
                    expression: "form.virtualHBL"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.FormalHbl")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "vgm" },
                  model: {
                    value: _vm.form.vgm,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "vgm", $$v)
                    },
                    expression: "form.vgm"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Vgm")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "ams" },
                  model: {
                    value: _vm.form.ams,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "ams", $$v)
                    },
                    expression: "form.ams"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Anti_terrorismShipping")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "hds" },
                  model: {
                    value: _vm.form.hds,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "hds", $$v)
                    },
                    expression: "form.hds"
                  }
                },
                [_vm._v("HDS")]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "comercialInspectation" },
                  model: {
                    value: _vm.form.comercialInspectation,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "comercialInspectation", $$v)
                    },
                    expression: "form.comercialInspectation"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CommodityInspection")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "heating" },
                  model: {
                    value: _vm.form.heating,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "heating", $$v)
                    },
                    expression: "form.heating"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Fumigation")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "itmService" },
                  model: {
                    value: _vm.form.itmService,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "itmService", $$v)
                    },
                    expression: "form.itmService"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ForeignTrade")))]
              ),
              _vm.isBookingNew
                ? _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { no: "destinationPortService" },
                      model: {
                        value: _vm.form.destinationPortService,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destinationPortService", $$v)
                        },
                        expression: "form.destinationPortService"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.PortOfDestinationServices"))
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "manifest" },
                  model: {
                    value: _vm.form.manifest,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "manifest", $$v)
                    },
                    expression: "form.manifest"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Manifest")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "seaRailwayTransportation" },
                  model: {
                    value: _vm.form.seaRailwayTransportation,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "seaRailwayTransportation", $$v)
                    },
                    expression: "form.seaRailwayTransportation"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SeaRailTransport")))]
              ),
              !!_vm.templateName
                ? _c("div", { staticStyle: { "flex-grow": "1" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        staticStyle: {
                          float: "right",
                          "margin-right": "30px",
                          padding: "0 5px",
                          "white-space": "nowrap"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_SopTemplate")) +
                            ": " +
                            _vm._s(_vm.templateName)
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "tab-booking-FCLUICustom-layout",
        { attrs: { "element-blocks": _vm.elementBlocks } },
        [
          _vm.elementDict.jobNo.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "jobNo" }, slot: "jobNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.jobNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.jobNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { value: _vm.form.jobNo, disabled: true }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isZY
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: { slot: "saleProductCode" },
                    slot: "saleProductCode"
                  },
                  [
                    _c("line-label", {
                      staticClass: "blue",
                      attrs: {
                        slot: "label",
                        label: _vm.$t("SeaExport.AllowSaleProduct")
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        "select-type":
                          _vm.selectTypeNames.basic_data_AllowSaleProduct,
                        filterable: "",
                        no: "allowSaleProduct",
                        clearable: "",
                        "data-filter-function": function(p) {
                          if (!p.statusEnabled) {
                            return false
                          }
                          return _vm.isFba ? p.fbaSea : p.seaExportEnabled
                        },
                        "default-value": this.form.saleProductCode || "",
                        disabled: _vm.readonly
                      },
                      on: {
                        parentCallBack: function(p) {
                          this$1.form.saleProductCode = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { slot: "fullOrInside" }, slot: "fullOrInside" },
                  [
                    _c("line-label", {
                      staticClass: "blue",
                      attrs: {
                        slot: "label",
                        label: _vm.$t("SeaExport.FullOrInside")
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        "select-type":
                          _vm.selectTypeNames
                            .local_cache_FullOrInside$FULL_OR_INSIDE,
                        no: "fullOrInside",
                        clearable: "",
                        "default-value": this.form.fullOrInside || "",
                        disabled: _vm.readonly
                      },
                      on: {
                        parentCallBack: function(p) {
                          this$1.form.fullOrInside = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.elementDict.customerId.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerId" }, slot: "customerId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerId.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" }
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.sopImageB,
                              expression: "sopImageB"
                            }
                          ],
                          attrs: {
                            content: _vm.$t("SeaExport.SOPReceiver"),
                            placement: "right-end"
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "sop-img",
                            class:
                              _vm.form.customerId && _vm.readonly
                                ? ""
                                : "not-click",
                            staticStyle: {
                              padding: "5px 0",
                              "vertical-align": "bottom",
                              cursor: "pointer"
                            },
                            attrs: {
                              src: _vm.sopPic,
                              width: "18",
                              height: "28"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.sopChangeCustomerIdHandler()
                              }
                            }
                          })
                        ]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showWarningImageB,
                              expression: "showWarningImageB"
                            }
                          ],
                          attrs: {
                            content: _vm.warningImageBTip,
                            placement: "right-end"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning red",
                            staticStyle: { cursor: "pointer" }
                          })
                        ]
                      ),
                      !_vm.isFba
                        ? _c("cargo-sales-company-select", {
                            staticClass: "shipper-selector",
                            class: _vm.importDifferenceField.customerId
                              ? "red-border"
                              : "",
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "customerId",
                              "popper-class": "shipper-selector-popper",
                              "method-params": {
                                customer: true,
                                companyLob: "seaExport",
                                active: true
                              },
                              "check-credit": true,
                              "default-value": _vm.form.customerId || "",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.customerId.writable ||
                                !_vm.customerEnabled,
                              job: _vm.form,
                              "latest-used-data-key":
                                _vm.elementDict.customerId.userCustomContent &&
                                _vm.elementDict.customerId.userCustomContent
                                  .recentlyUsedDropdownData
                                  ? "seaBooking-customerId"
                                  : ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.customerIdChange2ContractHandler(p)
                                _vm.clearPoNo()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.isFba
                        ? _c("cargo-company-select", {
                            staticClass: "shipper-selector",
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "customerId",
                              "popper-class": "shipper-selector-popper",
                              "method-params": {
                                customer: true,
                                companyLob: "seaExport",
                                active: true,
                                fba: true
                              },
                              "check-credit": true,
                              job: _vm.form,
                              "default-value": _vm.form.customerId || "",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.customerId.writable ||
                                !_vm.customerEnabled,
                              "data-filter-function": _vm.fbaCustomerIdFilter
                            },
                            on: {
                              change: function(p) {
                                _vm.customerIdChange2ContractHandler(p)
                                _vm.clearPoNo()
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerProperty.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "customerProperty" },
                  slot: "customerProperty"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerProperty.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerProperty.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-tooltip",
                    {
                      attrs: { content: _vm.customerTip, placement: "bottom" }
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.contractStatus === 2 &&
                                  typeof _vm.customerLevel.level ===
                                    "number") ||
                                parseInt(_vm.customerLevel.level) > -1,
                              expression:
                                "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                            }
                          ],
                          staticClass: "orange"
                        },
                        [_vm._v("LV" + _vm._s(_vm.customerLevel.level))]
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.contractStatus === 2 &&
                                  typeof _vm.customerLevel.level ===
                                    "number") ||
                                parseInt(_vm.customerLevel.level) > -1,
                              expression:
                                "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                            }
                          ],
                          staticStyle: { color: "#D3A73B" }
                        },
                        [_vm._v(" " + _vm._s(_vm.customerLevel.customerName))]
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.contractStatusLabel,
                              expression: "contractStatusLabel"
                            }
                          ],
                          staticClass: "red"
                        },
                        [_vm._v(" (" + _vm._s(_vm.contractStatusLabel) + ")")]
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.advancePaymentLabel,
                              expression: "advancePaymentLabel"
                            }
                          ],
                          staticStyle: { color: "brown" }
                        },
                        [_vm._v(" (" + _vm._s(_vm.advancePaymentLabel) + ")")]
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.stampPictureView.businessDocuments.length >
                                0,
                              expression:
                                "stampPictureView.businessDocuments.length > 0"
                            }
                          ],
                          on: {
                            click: function($event) {
                              _vm.stampPictureView.visible = true
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticStyle: { "text-align": "right" },
                            attrs: {
                              title: _vm.$t("Message.BookingSeal"),
                              src: _vm.stampIcon,
                              height: "14"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerContact.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerContact" }, slot: "customerContact" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerContact.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerContact.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-select",
                        {
                          class: _vm.importDifferenceField.customerContact
                            ? "red-border"
                            : "",
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.customerContact.writable,
                            no: "customerContact",
                            "field-name": "contactPerson",
                            filterable: "",
                            "allow-create": true
                          },
                          model: {
                            value: _vm.form.customerContact,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "customerContact", $$v)
                            },
                            expression: "form.customerContact"
                          }
                        },
                        _vm._l(_vm.contactList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.contactPerson,
                              value: item.contactPerson
                            }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-link",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isShowContactPersonDetail,
                              expression: "!isShowContactPersonDetail"
                            }
                          ],
                          class: _vm.form.customerContact ? "" : "not-click",
                          attrs: { no: "customerContactLink" },
                          on: { click: _vm.showContactDialog }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Detail")) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.containerLoadType.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "containerLoadType" },
                  slot: "containerLoadType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.containerLoadType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.containerLoadType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      class: _vm.importDifferenceField.containerLoadType
                        ? "red-border"
                        : "",
                      attrs: {
                        no: "containerLoadType",
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.containerLoadType.writable ||
                          !(_vm.isEdit && _vm.lclslaveEnabled)
                      },
                      on: {
                        change: function(val) {
                          _vm.pm.containerLoadTypeChange(val)
                        }
                      },
                      model: {
                        value: _vm.form.containerLoadType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "containerLoadType", $$v)
                        },
                        expression: "form.containerLoadType"
                      }
                    },
                    _vm._l(_vm.containerLoadTypes, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoType.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoType" }, slot: "cargoType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      class: _vm.importDifferenceField.cargoType
                        ? "red-border"
                        : "",
                      attrs: {
                        disabled:
                          _vm.readonly || !_vm.elementDict.cargoType.writable,
                        filterable: ""
                      },
                      on: {
                        change: function(val) {
                          _vm.cargoTypeChange(val)
                        }
                      },
                      model: {
                        value: _vm.form.cargoType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cargoType", $$v)
                        },
                        expression: "form.cargoType"
                      }
                    },
                    _vm._l(_vm.cargoType4JobSelect, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.salesChannel.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "salesChannel" }, slot: "salesChannel" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.salesChannel.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.salesChannel.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { value: _vm.form.salesChannel, disabled: true }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.channelNo.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "channelNo" }, slot: "channelNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.channelNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.channelNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { value: _vm.form.channelNo, disabled: true }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.trustFromJob.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "trustFromJob" }, slot: "trustFromJob" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.trustFromJob.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.trustFromJob.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { value: _vm.form.trustFromJob, disabled: true }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.relatedJob && _vm.elementDict.relatedJob.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "relatedJob" }, slot: "relatedJob" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.relatedJob.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.relatedJob.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { value: _vm.form.relatedJob, disabled: true }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.quotationNo.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "quotationNo" }, slot: "quotationNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.quotationNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.quotationNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { value: _vm.form.quotationNo, disabled: true }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.bookingDate.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "bookingDate" }, slot: "bookingDate" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.bookingDate.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.bookingDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    class: _vm.importDifferenceField.bookingDate
                      ? "red-border"
                      : "",
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "bookingDate",
                      disabled:
                        _vm.readonly || !_vm.elementDict.bookingDate.writable,
                      type: "date",
                      clearable: "",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.form.bookingDate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "bookingDate", $$v)
                      },
                      expression: "form.bookingDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.etd.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "etd" }, slot: "etd" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.etd.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.etd.label },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "departure-date-picker",
                        class: _vm.importDifferenceField.etd
                          ? "red-border"
                          : "",
                        staticStyle: { flex: "1", "margin-right": "5px" },
                        attrs: {
                          no: "etd",
                          value: _vm.form.etd,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.etd.writable ||
                            (_vm.form.lclMasterUuid ? true : !_vm.etdEnabled) ||
                            _vm.canEditInternalDelegatedJobField ||
                            !_vm.isJydEditJobFields ||
                            _vm.provisionEtdLocked,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: {
                          input: _vm.etdChange,
                          change: function($event) {
                            return _vm.onFieldChange("etd")
                          }
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("filterWeek")(_vm.form.sailingDay))
                        )
                      ])
                    ],
                    1
                  ),
                  _vm.provisionEtdLocked
                    ? _c(
                        "span",
                        { staticStyle: { color: "red", "font-size": "12px" } },
                        [_vm._v("(已计提校准不可修改)")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.eta.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "eta" }, slot: "eta" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.eta.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.eta.label },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        class: _vm.importDifferenceField.eta
                          ? "red-border"
                          : "",
                        staticStyle: { flex: "1", "margin-right": "5px" },
                        attrs: {
                          no: "eta",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.eta.writable ||
                            !_vm.lclslaveEnabled ||
                            _vm.canEditInternalDelegatedJobField,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { input: _vm.etaChange },
                        model: {
                          value: _vm.form.eta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "eta", $$v)
                          },
                          expression: "form.eta"
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("filterWeek")(_vm.form.etaSailingDay))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.atd.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "atd" }, slot: "atd" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.atd.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.atd.label },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { flex: "1", "margin-right": "5px" },
                        attrs: {
                          value: _vm.form.atd,
                          no: "atd",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.atd.writable ||
                            !_vm.lclslaveEnabled ||
                            _vm.canEditInternalDelegatedJobField,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { input: _vm.atdChange }
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("filterWeek")(_vm.form.atdSailingDay))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.ata.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "ata" }, slot: "ata" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.ata.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.ata.label },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { flex: "1", "margin-right": "5px" },
                        attrs: {
                          no: "ata",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.ata.writable ||
                            !_vm.lclslaveEnabled ||
                            _vm.canEditInternalDelegatedJobField,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { input: _vm.ataChange },
                        model: {
                          value: _vm.form.ata,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ata", $$v)
                          },
                          expression: "form.ata"
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("filterWeek")(_vm.form.ataSailingDay))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDate.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "customsDate" }, slot: "customsDate" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDate.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    class: _vm.importDifferenceField.customsDate
                      ? "red-border"
                      : "",
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "customsDate",
                      type: "date",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.customsDate.writable ||
                        !_vm.isJydUpdateCustomsDate,
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.form.customsDate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "customsDate", $$v)
                      },
                      expression: "form.customsDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dispatchingPlaceCode.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "dispatchingPlaceCode" },
                  slot: "dispatchingPlaceCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dispatchingPlaceCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dispatchingPlaceCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.dispatchingPlaceCode
                      ? "red-border"
                      : "",
                    staticStyle: { flex: "1" },
                    attrs: {
                      no: "dispatchingPlaceCode",
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      placeholder: _vm.$t("SeaExport.PlaceHolderPOR"),
                      filterable: "",
                      "default-value": _vm.form.dispatchingPlaceCode,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.dispatchingPlaceCode.writable,
                      "tag-name": "englishName"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.changeDispatchingPlaceCode(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dispatchingPlace.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "dispatchingPlace" },
                  slot: "dispatchingPlace"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dispatchingPlace.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dispatchingPlace.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    class: _vm.importDifferenceField.dispatchingPlace
                      ? "red-border"
                      : "",
                    attrs: {
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.dispatchingPlace.writable,
                      no: "dispatchingPlace"
                    },
                    on: {
                      change: function($event) {
                        _vm.pm.cargoDocChangeHandler()
                        _vm.pm.changeDispatchingPlace()
                      }
                    },
                    model: {
                      value: _vm.form.dispatchingPlace,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "dispatchingPlace", $$v)
                      },
                      expression: "form.dispatchingPlace"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.loadingPortCode.viewable,
                  expression: "elementDict.loadingPortCode.viewable"
                }
              ],
              attrs: { slot: "loadingPortCode" },
              slot: "loadingPortCode"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.loadingPortCode.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.loadingPortCode.label
                },
                slot: "label"
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    ref: "loadingPortCode",
                    class: _vm.importDifferenceField.loadingPortCode
                      ? "red-border"
                      : "",
                    staticStyle: { flex: "1" },
                    attrs: {
                      no: "loadingPortCode",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.loadingPortCode.writable,
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.loadingPortCode,
                      "tag-name": "englishName",
                      "latest-used-data-key":
                        _vm.elementDict.loadingPortCode.userCustomContent &&
                        _vm.elementDict.loadingPortCode.userCustomContent
                          .recentlyUsedDropdownData
                          ? "seaBooking-loadingPortCode"
                          : ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.loadingPortCodeChange(p)
                        _vm.pm.cargoDocChangeHandler()
                        _vm.pm.changeLoadingPort()
                        _vm.pm.setPlannerChange()
                      }
                    }
                  }),
                  _vm.elementDict.transferPortCode.viewable
                    ? [
                        _vm._v(" "),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "padding-left": "2px" },
                            attrs: {
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.loadingPortCode.writable,
                              no: "transfering"
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.updateSecondVesselInfo()
                              }
                            },
                            model: {
                              value: _vm.form.transfering,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "transfering", $$v)
                              },
                              expression: "form.transfering"
                            }
                          },
                          [_vm._v(_vm._s(_vm.fieldDict.transfering.label))]
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm.elementDict.transferPortCode.viewable && _vm.form.transfering
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "transferPortCode" },
                  slot: "transferPortCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transferPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transferPortCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "transferPortCode",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.transferPortCode.writable ||
                        !_vm.lclslaveEnabled,
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.transferPortCode
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.transferPortCode = p.value
                        _vm.pm.updateSecondVesselInfo()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dischargingPortCode.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "dischargingPortCode" },
                  slot: "dischargingPortCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dischargingPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dischargingPortCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.dischargingPortCode
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "dischargingPortCode",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.dischargingPortCode.writable ||
                        !_vm.lclslaveEnabled,
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.dischargingPortCode,
                      "latest-used-data-key":
                        _vm.elementDict.dischargingPortCode.userCustomContent &&
                        _vm.elementDict.dischargingPortCode.userCustomContent
                          .recentlyUsedDropdownData
                          ? "seaBooking-dischargingPortCode"
                          : ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.dischargingPortCodeChange(
                          p.value,
                          _vm.form.carrierId
                        )
                        _vm.pm.cargoDocChangeHandler()
                        _vm.pm.changeDischargingPort()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationPortCode.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationPortCode" },
                  slot: "destinationPortCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationPortCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticClass: "port-of-delivery-selector",
                    class: _vm.importDifferenceField.destinationPortCode
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "destinationPortCode",
                      "popper-class": "port-of-delivery-selector-popper",
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.destinationPortCode,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.destinationPortCode.writable,
                      "latest-used-data-key":
                        _vm.elementDict.destinationPortCode.userCustomContent &&
                        _vm.elementDict.destinationPortCode.userCustomContent
                          .recentlyUsedDropdownData
                          ? "seaBooking-destinationPortCode"
                          : ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.destinationPortCodeChange(p)
                        _vm.pm.cargoDocChangeHandler()
                        _vm.pm.changeDestinationPort()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.placeOfDeliveryRegion.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "placeOfDeliveryRegion" },
                  slot: "placeOfDeliveryRegion"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.placeOfDeliveryRegion.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.placeOfDeliveryRegion.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.placeOfDeliveryRegion
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "placeOfDeliveryRegion",
                      "select-type": _vm.selectTypeNames.basic_data_Region,
                      filterable: "",
                      "default-value": _vm.form.placeOfDeliveryRegion,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.placeOfDeliveryRegion.writable
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.placeOfDeliveryRegion = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.transshipmentTransportationModeCode &&
          _vm.elementDict.transshipmentTransportationModeCode.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "transshipmentTransportationModeCode" },
                  slot: "transshipmentTransportationModeCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transshipmentTransportationModeCode
                      .isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label:
                        _vm.elementDict.transshipmentTransportationModeCode
                          .label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "transportationMode",
                      "static-options": _vm.transportationModeInfos,
                      "filter-tag-names": [
                        "chineseName",
                        "englishName",
                        "code"
                      ],
                      filterable: "",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.transshipmentTransportationModeCode
                          .writable,
                      "tag-name": "englishName",
                      "default-value":
                        _vm.form.transshipmentTransportationModeCode
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.transshipmentTransportationModeCode = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.inquiryPriceNo &&
          _vm.elementDict.inquiryPriceNo.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "inquiryPriceNo" }, slot: "inquiryPriceNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.inquiryPriceNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.inquiryPriceNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "inquiryPriceNo",
                      value: _vm.form.inquiryPriceNo,
                      disabled: ""
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.prePortQuotationNo &&
          _vm.elementDict.prePortQuotationNo.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "prePortQuotationNo" },
                  slot: "prePortQuotationNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.prePortQuotationNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.prePortQuotationNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "prePortQuotationNo",
                      value: _vm.form.prePortQuotationNo,
                      disabled: ""
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.lastMileQuotationNo &&
          _vm.elementDict.lastMileQuotationNo.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "lastMileQuotationNo" },
                  slot: "lastMileQuotationNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.lastMileQuotationNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.lastMileQuotationNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "lastMileQuotationNo",
                      value: _vm.form.lastMileQuotationNo,
                      disabled: ""
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.vesselLine.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "vesselLine" }, slot: "vesselLine" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.vesselLine.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.vesselLine.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { value: _vm.pm.vesselLine, disabled: true }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationPlace.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationPlace" },
                  slot: "destinationPlace"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationPlace.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationPlace.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    class: _vm.importDifferenceField.destinationPlace
                      ? "red-border"
                      : "",
                    attrs: {
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.destinationPlace.writable,
                      no: "destinationPlace"
                    },
                    on: {
                      change: function($event) {
                        _vm.pm.cargoDocChangeHandler()
                        _vm.pm.changeDestinationPlace()
                      }
                    },
                    model: {
                      value: _vm.form.destinationPlace,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "destinationPlace", $$v)
                      },
                      expression: "form.destinationPlace"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.carrierId.viewable,
                  expression: "elementDict.carrierId.viewable"
                }
              ],
              attrs: { slot: "carrierId" },
              slot: "carrierId"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.carrierId.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.carrierId.label
                },
                slot: "label"
              }),
              _c("cargo-company-select", {
                ref: "shippingCompany",
                class: _vm.importDifferenceField.carrierId ? "red-border" : "",
                attrs: {
                  no: "carrierId",
                  disabled:
                    _vm.readonly ||
                    !_vm.elementDict.carrierId.writable ||
                    !_vm.carrierIdEnabled,
                  "method-params": {
                    companyLob: "seaExport",
                    seaCmp: true,
                    active: true
                  },
                  "default-value": _vm.form.carrierId || "",
                  "latest-used-data-key":
                    _vm.elementDict.carrierId.userCustomContent &&
                    _vm.elementDict.carrierId.userCustomContent
                      .recentlyUsedDropdownData
                      ? "seaBooking-carrierId"
                      : ""
                },
                on: {
                  change: function(p) {
                    _vm.pm.carrierChangeHandler(
                      _vm.form.dischargingPortCode,
                      p.value,
                      this$1.scacList,
                      this$1.carrierScacEdit
                    )
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.carrierScac && _vm.elementDict.carrierScac.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "carrierScac" }, slot: "carrierScac" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.carrierScac.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.carrierScac.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "carrierScac",
                      filterable: "",
                      "custom-label": function(item) {
                        return (
                          "[" +
                          item.code +
                          "]" +
                          (item.englishName ? item.englishName : item.code)
                        )
                      },
                      "filter-tag-names": ["code", "englishName"],
                      "show-custom-label-in-option": true,
                      "static-options": _vm.scacList,
                      "tag-value": "code",
                      disabled:
                        _vm.readonly ||
                        !_vm.carrierScacEdit ||
                        !_vm.elementDict.carrierScac.writable,
                      "default-value": _vm.form.carrierScac || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.carrierScac = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.carrierWebsite &&
          _vm.elementDict.carrierWebsite.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "carrierWebsite" }, slot: "carrierWebsite" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.carrierWebsite.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.carrierWebsite.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-textarea", {
                    attrs: {
                      no: "carrierWebsite",
                      type: "textarea",
                      row: 3,
                      disabled:
                        _vm.readonly || !_vm.elementDict.carrierWebsite.writable
                    },
                    model: {
                      value: _vm.form.carrierWebsite,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "carrierWebsite", $$v)
                      },
                      expression: "form.carrierWebsite"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.bookingAgent.viewable && _vm.bookingAgentVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "bookingAgent" }, slot: "bookingAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.bookingAgent.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.bookingAgent.label
                    },
                    slot: "label"
                  }),
                  !_vm.bookingAgentDataProviderChange
                    ? _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.bookingAgent
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "bookingAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          filterable: "",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.bookingAgent.writable ||
                            !_vm.bookingAgentEnabled,
                          "method-params": {
                            bookingAgent: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.form.bookingAgent || "",
                          "latest-used-data-key":
                            _vm.elementDict.bookingAgent.userCustomContent &&
                            _vm.elementDict.bookingAgent.userCustomContent
                              .recentlyUsedDropdownData
                              ? "seaBooking-bookingAgent"
                              : ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.bookingAgentChangeHandler(p)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.bookingAgentDataProviderChange
                    ? _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.bookingAgent
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "bookingAgent",
                          cache: false,
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.bookingAgent.writable ||
                            !_vm.bookingAgentEnabled,
                          "default-value": _vm.form.bookingAgent || "",
                          "static-options": _vm.pm.bookingAgentArray,
                          "latest-used-data-key":
                            _vm.elementDict.bookingAgent.userCustomContent &&
                            _vm.elementDict.bookingAgent.userCustomContent
                              .recentlyUsedDropdownData
                              ? "seaBooking-bookingAgent"
                              : ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.bookingAgentChangeHandler()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.carrierAgentId.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "carrierAgentId" }, slot: "carrierAgentId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.carrierAgentId.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.carrierAgentId.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    class: _vm.importDifferenceField.carrierAgentId
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "carrierAgentId",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.carrierAgentId.writable ||
                        !_vm.lclslaveEnabled,
                      "method-params": {
                        seaCmpAgent: true,
                        companyLob: "seaExport",
                        active: true
                      },
                      "default-value": _vm.form.carrierAgentId || ""
                    },
                    on: {
                      change: function(p) {
                        _vm.form.carrierAgentId = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.terminalCompany.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "terminalCompany" }, slot: "terminalCompany" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.terminalCompany.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.terminalCompany.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    class: _vm.importDifferenceField.terminalCompany
                      ? "red-border"
                      : "",
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "terminalCompany",
                      "method-params": {
                        terminalCompany: true,
                        companyLob: "seaExport",
                        active: true
                      },
                      "default-value": _vm.form.terminalCompany || "",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.terminalCompany.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.JobUtils.terminalCompanyChangeHandler(_vm.form, p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoSource.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoSource" }, slot: "cargoSource" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoSource.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoSource.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      class: _vm.importDifferenceField.cargoSource
                        ? "red-border"
                        : "",
                      attrs: {
                        no: "cargoSource",
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.cargoSource.writable ||
                          !_vm.cargoSourceEnabled,
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        size: "mini"
                      },
                      on: {
                        change: function($event) {
                          _vm.form.designationAgent = 0
                          _vm.pm.cargoSourceChange({ fieldName: "cargoSource" })
                        }
                      },
                      model: {
                        value: _vm.form.cargoSource,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cargoSource", $$v)
                        },
                        expression: "form.cargoSource"
                      }
                    },
                    _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.customJobType.viewable,
                  expression: "elementDict.customJobType.viewable"
                }
              ],
              attrs: { slot: "customJobType" },
              slot: "customJobType"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.customJobType.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.customJobType.label
                },
                slot: "label"
              }),
              _c("cargo-advance-select", {
                ref: "customJobType",
                class: _vm.importDifferenceField.customJobType
                  ? "red-border"
                  : "",
                attrs: {
                  no: "customJobType",
                  "select-type": _vm.selectTypeNames.basic_data_CutomJobType,
                  filterable: "",
                  "default-value": _vm.form.customJobType,
                  disabled:
                    _vm.readonly || !_vm.elementDict.customJobType.writable,
                  "tag-name": _vm.isZh ? "name" : "englishName",
                  "method-params": { type: _vm.form.lob },
                  "static-options": _vm.customJobTypeList
                },
                on: {
                  parentCallBack: function(p) {
                    _vm.form.customJobType = p.value
                    _vm.onCustomJobTypeChange()
                    _vm.contractRuleFieldChange(
                      _vm.form.customerId,
                      _vm.form.designationAgent
                    )
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.elementDict.secondaryCustomJobType.viewable &&
                    _vm.form.customJobType &&
                    _vm.secondaryCustomJobTypeList.length > 0,
                  expression:
                    "elementDict.secondaryCustomJobType.viewable && form.customJobType && secondaryCustomJobTypeList.length > 0"
                }
              ],
              attrs: { slot: "secondaryCustomJobType" },
              slot: "secondaryCustomJobType"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.secondaryCustomJobType.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.secondaryCustomJobType.label
                },
                slot: "label"
              }),
              _c("cargo-advance-select", {
                ref: "secondaryCustomJobType",
                attrs: {
                  no: "secondaryCustomJobType",
                  "select-type": _vm.selectTypeNames.basic_data_CutomJobType,
                  filterable: "",
                  cache: false,
                  "default-value": _vm.form.secondaryCustomJobType,
                  disabled:
                    _vm.readonly ||
                    !_vm.elementDict.secondaryCustomJobType.writable,
                  "tag-name": _vm.isZh ? "name" : "englishName",
                  "static-options": _vm.secondaryCustomJobTypeList
                },
                on: {
                  parentCallBack: function(p) {
                    _vm.form.secondaryCustomJobType = p.value
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.destinationAgent.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationAgent" },
                  slot: "destinationAgent"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationAgent.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" }
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.sopImageC,
                              expression: "sopImageC"
                            }
                          ],
                          attrs: {
                            content: _vm.$t("SeaExport.SOPReceiver"),
                            placement: "right-end"
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "sop-img",
                            class:
                              _vm.form.destinationAgent && _vm.readonly
                                ? ""
                                : "not-click",
                            staticStyle: {
                              padding: "5px 0",
                              cursor: "pointer"
                            },
                            attrs: {
                              src: _vm.sopPic,
                              width: "18",
                              height: "28"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.sopChangeHandler()
                              }
                            }
                          })
                        ]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showWarningImageC,
                              expression: "showWarningImageC"
                            }
                          ],
                          attrs: {
                            content: _vm.warningImageCTip,
                            placement: "right-end"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning red",
                            staticStyle: { cursor: "pointer" }
                          })
                        ]
                      ),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.destinationAgent
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "destinationAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.destinationAgent.writable ||
                            !_vm.lclslaveEnabled,
                          "method-params": {
                            overseaAgent: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.form.destinationAgent || "",
                          filterable: "",
                          headers: [_vm.$t("Partners.englishName")],
                          fields: ["englishName"],
                          "tag-name": "englishName",
                          "latest-used-data-key":
                            _vm.elementDict.destinationAgent
                              .userCustomContent &&
                            _vm.elementDict.destinationAgent.userCustomContent
                              .recentlyUsedDropdownData
                              ? "seaBooking-destinationAgent"
                              : ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.txtDestinationAgentChangeHandler(p)
                          }
                        }
                      }),
                      _vm.overseaAgentDataProviderChange
                        ? _c("cargo-advance-select", {
                            attrs: {
                              no: "destinationAgent2",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              cache: false,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.destinationAgent.writable ||
                                !_vm.lclslaveEnabled,
                              "default-value": _vm.form.destinationAgent || "",
                              filterable: "",
                              "check-credit": true,
                              headers: [_vm.$t("Partners.englishName")],
                              fields: ["englishName"],
                              "tag-name": "englishName",
                              "static-options": _vm.pm.destinationAgentArray,
                              "latest-used-data-key":
                                _vm.elementDict.destinationAgent
                                  .userCustomContent &&
                                _vm.elementDict.destinationAgent
                                  .userCustomContent.recentlyUsedDropdownData
                                  ? "seaBooking-destinationAgent"
                                  : ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.txtDestinationAgentChangeHandler(p)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.designationAgent.viewable &&
          _vm.form.cargoSource === "NC"
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "designationAgent" },
                  slot: "designationAgent"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.designationAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.designationAgent.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" }
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.sopImageA,
                              expression: "sopImageA"
                            }
                          ],
                          attrs: {
                            content: _vm.$t("SeaExport.SOPReceiver"),
                            placement: "right-end"
                          }
                        },
                        [
                          _c("div", [
                            _c("img", {
                              staticClass: "sop-img",
                              class:
                                _vm.form.designationAgent && _vm.readonly
                                  ? ""
                                  : "not-click",
                              staticStyle: {
                                padding: "5px 0",
                                cursor: "pointer"
                              },
                              attrs: {
                                src: _vm.sopPic,
                                width: "18",
                                height: "28"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.sopChangeBookingAgentHandler()
                                }
                              }
                            })
                          ])
                        ]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showWarningImageA,
                              expression: "showWarningImageA"
                            }
                          ],
                          attrs: {
                            content: _vm.warningImageATip,
                            placement: "right-end"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning red",
                            staticStyle: { cursor: "pointer" }
                          })
                        ]
                      ),
                      _c("cargo-advance-select", {
                        staticClass: "designation-agent-selector",
                        attrs: {
                          no: "designationAgent",
                          "popper-class": "designation-agent-selector-popper",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.designationAgent.writable ||
                            !_vm.designationAgentEnabled,
                          "method-params": {
                            designationAgent: true,
                            active: true
                          },
                          "check-credit": true,
                          "default-value": _vm.form.designationAgent || "",
                          filterable: "",
                          headers: [_vm.$t("Partners.englishName")],
                          fields: ["englishName"],
                          "tag-name": "englishName"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.designationAgentChangeHandler(p)
                          }
                        }
                      }),
                      _vm.overseaAgentDataProviderChange
                        ? _c("cargo-advance-select", {
                            attrs: {
                              no: "designationAgent2",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              cache: false,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.designationAgent.writable ||
                                !_vm.designationAgentEnabled,
                              "check-credit": true,
                              "default-value": _vm.form.designationAgent || "",
                              filterable: "",
                              headers: [_vm.$t("Partners.englishName")],
                              fields: ["englishName"],
                              "tag-name": "englishName",
                              "static-options": _vm.pm.designationAgentArray
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.designationAgentChangeHandler(p)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.exChangeAgent.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "exChangeAgent" }, slot: "exChangeAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.exChangeAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.exChangeAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    attrs: {
                      no: "exChangeAgent",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.exChangeAgent.writable ||
                        !_vm.form.destinationPortService,
                      "method-params": { bookingAgent: true, active: true },
                      "default-value": _vm.form.exChangeAgent || ""
                    },
                    on: { change: _vm.onExChangeAgentChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.transportSource.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "transportSource" }, slot: "transportSource" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transportSource.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transportSource.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      filterable: "",
                      "select-type":
                        _vm.selectTypeNames.basic_data_TransportSource,
                      no: "transportSource",
                      "default-value": _vm.form.transportSource,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.transportSource.writable,
                      cache: false,
                      "tag-value": "code",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.form.transportSource = item.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.statisticArea.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "statisticArea" }, slot: "statisticArea" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.statisticArea.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.statisticArea.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      filterable: "",
                      "select-type":
                        _vm.selectTypeNames.basic_data_StatisticArea,
                      no: "statisticArea",
                      "default-value": _vm.form.statisticArea,
                      disabled:
                        _vm.readonly || !_vm.elementDict.statisticArea.writable,
                      cache: false,
                      "tag-value": "code",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.form.statisticArea = item.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDeclaration &&
          _vm.elementDict.customsDeclaration.viewable
            ? _c(
                "template",
                { slot: "customsDeclaration" },
                [
                  _vm.slaveCustomsDeclarationEnable
                    ? _c("customs-declaration", {
                        ref: "customsDeclaration",
                        attrs: {
                          no: "customsDeclaration",
                          job: _vm.form,
                          "is-editing":
                            !_vm.readonly &&
                            _vm.elementDict.customsDeclaration.writable,
                          "del-po-items-uuids": _vm.delPoItemsUuids
                        },
                        on: {
                          quantityActualChange: _vm.quantityActualChange,
                          weightActualChange: _vm.weightActualChange,
                          cubageActualChange: _vm.cubageActualChange
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.localService.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "localService" }, slot: "localService" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.localService.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.localService.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.localService.writable,
                        no: "warehousing"
                      },
                      on: {
                        change: function($event) {
                          return _vm.pm.loadingTermChange("warehousing")
                        }
                      },
                      model: {
                        value: _vm.form.warehousing,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "warehousing", $$v)
                        },
                        expression: "form.warehousing"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.WarehouseLoadingStorage")) +
                          " "
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.localService.writable,
                        no: "landTransportation"
                      },
                      on: {
                        change: function($event) {
                          return _vm.pm.loadingTermChange("landTransportation")
                        }
                      },
                      model: {
                        value: _vm.form.landTransportation,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "landTransportation", $$v)
                        },
                        expression: "form.landTransportation"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.DoorLoadingDelivery")) + " "
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.localService.writable,
                        no: "selfDeliver"
                      },
                      model: {
                        value: _vm.form.selfDeliver,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "selfDeliver", $$v)
                        },
                        expression: "form.selfDeliver"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "SeaExport.NotResponsibleForTruckingAndLoading"
                          )
                        ) + " "
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.localService.writable,
                        no: "backUpWarehouse"
                      },
                      on: {
                        change: function($event) {
                          return _vm.pm.backUpWarehouseChange()
                        }
                      },
                      model: {
                        value: _vm.form.backUpWarehouse,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "backUpWarehouse", $$v)
                        },
                        expression: "form.backUpWarehouse"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.BackUpWarehouse")) + " ")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.localService.writable,
                        no: "otherService"
                      },
                      on: {
                        change: function($event) {
                          return _vm.pm.otherServiceChange()
                        }
                      },
                      model: {
                        value: _vm.form.otherService,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "otherService", $$v)
                        },
                        expression: "form.otherService"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Other")) + " ")]
                  ),
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.otherService,
                        expression: "form.otherService"
                      }
                    ],
                    class: _vm.importDifferenceField.otherRemark
                      ? "red-border"
                      : "",
                    attrs: {
                      disabled:
                        _vm.readonly || !_vm.elementDict.localService.writable,
                      no: "otherRemark",
                      maxlength: "10"
                    },
                    model: {
                      value: _vm.form.otherRemark,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "otherRemark", $$v)
                      },
                      expression: "form.otherRemark"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.portOfDestinationServices.viewable &&
          !_vm.isFba &&
          _vm.isBookingNew &&
          _vm.form.destinationPortService
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "portOfDestinationServices" },
                  slot: "portOfDestinationServices"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.portOfDestinationServices.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.portOfDestinationServices.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.portOfDestinationServices.writable,
                        no: "dischargingPortDoor"
                      },
                      model: {
                        value: _vm.form.dischargingPortDoor,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "dischargingPortDoor", $$v)
                        },
                        expression: "form.dischargingPortDoor"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SeaExport.DispatchVehiclesAtDestination")
                        ) + " "
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.portOfDestinationServices.writable,
                        no: "usCustomsClearance"
                      },
                      model: {
                        value: _vm.form.usCustomsClearance,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "usCustomsClearance", $$v)
                        },
                        expression: "form.usCustomsClearance"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("queryJob.UsCustomsClearance")) + " "
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.portOfDestinationServices.writable,
                        no: "destPortCustomsClearance"
                      },
                      model: {
                        value: _vm.form.destPortCustomsClearance,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destPortCustomsClearance", $$v)
                        },
                        expression: "form.destPortCustomsClearance"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SeaExport.PortOfDestinationCustomsClearance")
                        ) + " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isFba && _vm.isBookingNew && _vm.form.destinationPortService
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.PortOfDestinationServices")
                  }
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { disabled: _vm.readonly },
                      on: { change: _vm.addedServiceChangeHandler },
                      model: {
                        value: _vm.selectedPodAddedService,
                        callback: function($$v) {
                          _vm.selectedPodAddedService = $$v
                        },
                        expression: "selectedPodAddedService"
                      }
                    },
                    _vm._l(_vm.podAddedService, function(item) {
                      return _c(
                        "el-checkbox",
                        {
                          key: item.code,
                          staticStyle: { display: "block" },
                          attrs: { label: item.code },
                          on: {
                            change: function(val) {
                              return _vm.singleAddedServiceChangeHandler(
                                val,
                                item
                              )
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.warehouseNo.viewable
            ? _c(
                "template",
                { slot: "warehouseNo" },
                [
                  !_vm.jingyuWarehouse
                    ? _c(
                        "el-form-item",
                        { class: _vm.warehouseNoRed ? "warehouseClass" : "" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.warehouseNo.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.warehouseNo.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: {
                              no: "warehouseNo",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.warehouseNo.writable ||
                                !_vm.pm.warehouseNoeditable
                            },
                            model: {
                              value: _vm.form.warehouseNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "warehouseNo", $$v)
                              },
                              expression: "form.warehouseNo"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "padding-left": "13px",
                                "padding-right": "13px"
                              },
                              attrs: {
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.warehouseNo.writable ||
                                  !(_vm.isEdit && _vm.isHbl),
                                no: "ObtainTheWarehouseNo",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.clickWarehouseNoHandler()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.ObtainTheWarehouseNo")
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.jingyuWarehouse
                    ? _c(
                        "el-form-item",
                        { class: _vm.warehouseNoRed ? "warehouseClass" : "" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.warehouseNo.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.warehouseNo.label
                            },
                            slot: "label"
                          }),
                          _c("warehouse-no-input", {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: {
                              "job-warehouse-nos": _vm.jobWarehouseNos,
                              job: _vm.form,
                              no: "warehouseNo2",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.warehouseNo.writable ||
                                !_vm.pm.warehouseNoeditable
                            },
                            on: {
                              "update:jobWarehouseNos": function($event) {
                                _vm.jobWarehouseNos = $event
                              },
                              "update:job-warehouse-nos": function($event) {
                                _vm.jobWarehouseNos = $event
                              }
                            },
                            model: {
                              value: _vm.form.warehouseNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "warehouseNo", $$v)
                              },
                              expression: "form.warehouseNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.warehouseStatus.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "warehouseStatus", no: "WarehouseState" },
                  slot: "warehouseStatus"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.warehouseStatus.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.warehouseStatus.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: true,
                        placeholder: _vm.$t("Message.PleaseSelect"),
                        size: "mini"
                      },
                      model: {
                        value: _vm.form.warehouseStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "warehouseStatus", $$v)
                        },
                        expression: "form.warehouseStatus"
                      }
                    },
                    _vm._l(_vm.WarehouseInState.WAREHOUSE_STATE, function(
                      item,
                      index
                    ) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.masterBusinessNo.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "masterBusinessNo" },
                  slot: "masterBusinessNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.masterBusinessNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.masterBusinessNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: true,
                      value: _vm.form.lclMaster ? _vm.form.lclMaster.jobNo : ""
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerRefNo.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.customerRefNoRed ? "warehouseClass" : "",
                  attrs: { slot: "customerRefNo", id: "customerRefNo" },
                  slot: "customerRefNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerRefNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerRefNo.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        disabled: !_vm.customerRefNoTip,
                        content: _vm.customerRefNoTip,
                        placement: "right-end"
                      }
                    },
                    [
                      _c("el-input", {
                        class: _vm.customerRefNoTip ? "red" : "",
                        attrs: {
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.customerRefNo.writable,
                          no: "customerRefNo"
                        },
                        on: {
                          blur: function($event) {
                            return _vm.pm.customerRefNoFocusOutHandler()
                          }
                        },
                        model: {
                          value: _vm.form.customerRefNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customerRefNo", $$v)
                          },
                          expression: "form.customerRefNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.agentRefNo.viewable && _vm.form.cargoSource === "NC"
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "agentRefNo", id: "agentRefNo" },
                  slot: "agentRefNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.agentRefNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.agentRefNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        _vm.readonly || !_vm.elementDict.agentRefNo.writable,
                      no: "agentRefNo"
                    },
                    model: {
                      value: _vm.form.agentRefNo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "agentRefNo", $$v)
                      },
                      expression: "form.agentRefNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.poNo.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.poNoRed ? "warehouseClass" : "",
                  attrs: { slot: "poNo" },
                  slot: "poNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.poNo.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.poNo.label },
                    slot: "label"
                  }),
                  !_vm.openProjectConfig
                    ? _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonly || !_vm.elementDict.poNo.writable,
                          no: "poNo"
                        },
                        model: {
                          value: _vm.form.poNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "poNo", $$v)
                          },
                          expression: "form.poNo"
                        }
                      })
                    : _vm._e(),
                  _vm.openProjectConfig
                    ? _c("cargo-project-select", {
                        attrs: {
                          no: "poNo",
                          "default-value": _vm.form.poNo,
                          disabled:
                            _vm.readonly || !_vm.elementDict.poNo.writable,
                          "customer-id": _vm.form.customerId,
                          "is-linked": _vm.isProjectLinkedCustomer
                        },
                        on: {
                          change: function(p) {
                            _vm.form.poNo = p.value
                            _vm.form.projectName = p.projectName
                            _vm.changeProject()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.projectName.viewable && _vm.openProjectConfig
            ? _c(
                "el-form-item",
                { attrs: { slot: "projectName" }, slot: "projectName" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.projectName.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.projectName.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.projectName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "projectName", $$v)
                      },
                      expression: "form.projectName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.projectBatch.viewable && _vm.openProjectConfig
            ? _c(
                "el-form-item",
                { attrs: { slot: "projectBatch" }, slot: "projectBatch" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.projectBatch.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.projectBatch.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        _vm.readonly || !_vm.elementDict.projectBatch.writable,
                      no: "projectBatch"
                    },
                    model: {
                      value: _vm.form.projectBatch,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "projectBatch", $$v)
                      },
                      expression: "form.projectBatch"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsBroker.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "customsBroker" }, slot: "customsBroker" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsBroker.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsBroker.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customsBroker",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.customsBroker.writable ||
                        !_vm.customsBrokerEnabled,
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "data-filter-function": _vm.customsBrokerFilter,
                      filterable: "",
                      "default-value": _vm.form.customsBroker || "",
                      placeholder: !_vm.customsBrokerEnabled
                        ? _vm.$t("SeaExport.PleaseTickCustomsDeclarationOption")
                        : _vm.$t("CargoMsg.Cargo_keyWordsTip"),
                      "method-params": {
                        customsBroker: true,
                        companyLob: "seaExport",
                        active: true
                      }
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.customsBrokerChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDeclarationType.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "customsDeclarationType" },
                  slot: "customsDeclarationType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDeclarationType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDeclarationType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customsDeclarationType",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.customsDeclarationType.writable ||
                        !_vm.customsBrokerEnabled,
                      "select-type":
                        _vm.selectTypeNames.basic_data_CustomsDeclarationType,
                      filterable: "",
                      "default-value":
                        _vm.form.customsDeclarationType === -1
                          ? ""
                          : _vm.form.customsDeclarationType,
                      placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.customsDeclarationType = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.tradeTerm.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "tradeTerm" }, slot: "tradeTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.tradeTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.tradeTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "tradeTerm",
                      "select-type": _vm.selectTypeNames.basic_data_TradeTerm,
                      filterable: "",
                      "default-value": _vm.form.tradeTerm,
                      disabled:
                        _vm.readonly || !_vm.elementDict.tradeTerm.writable
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.tradeTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.haulageCompany.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "haulageCompany" }, slot: "haulageCompany" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.haulageCompany.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.haulageCompany.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    attrs: {
                      no: "carryingCmp",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.haulageCompany.writable ||
                        !_vm.form.landTransportation,
                      "method-params": { truckCmp: true, active: true },
                      "default-value": _vm.form.carryingCmp || "",
                      placeholder: !_vm.form.landTransportation
                        ? _vm.$t(
                            "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                          )
                        : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.carryingCmpChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isFba
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.DomesticWarehouse") } },
                [
                  _c("cargo-company-select", {
                    attrs: {
                      no: "warehouseCmp",
                      disabled: _vm.readonly || !_vm.warehouseEabled,
                      "method-params": { warehouse: true, active: true },
                      "default-value":
                        Number(_vm.fbaJob.domesticWarehouse) || "",
                      placeholder: !_vm.warehouseEabled
                        ? _vm.$t("SeaExport.PleaseSelectWarehouse")
                        : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.warehouseCmpChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.warehouseCmp.viewable && !_vm.isFba
            ? _c(
                "el-form-item",
                { attrs: { slot: "warehouseCmp" }, slot: "warehouseCmp" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.warehouseCmp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.warehouseCmp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    attrs: {
                      no: "warehouseCmp",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.warehouseCmp.writable ||
                        !_vm.warehouseEabled,
                      "method-params": { warehouse: true, active: true },
                      "default-value": _vm.form.warehouseCmp || "",
                      placeholder: !_vm.warehouseEabled
                        ? _vm.$t("SeaExport.PleaseSelectWarehouse")
                        : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.warehouseCmpChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.elementDict.warehouseName.viewable && _vm.openWarehouse,
                  expression:
                    "elementDict.warehouseName.viewable && openWarehouse"
                }
              ],
              attrs: { slot: "warehouseName" },
              slot: "warehouseName"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.warehouseName.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.warehouseName.label
                },
                slot: "label"
              }),
              _c(
                "el-select",
                {
                  ref: "warehouseName",
                  attrs: {
                    no: "warehouseName",
                    disabled:
                      _vm.readonly ||
                      !_vm.elementDict.warehouseName.writable ||
                      !_vm.warehouseEabled ||
                      !_vm.form.warehouseCmp,
                    "allow-create": true,
                    filterable: "",
                    clearable: true
                  },
                  on: { change: _vm.warehouseNameChangeHandler },
                  model: {
                    value: _vm.form.warehouseName,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "warehouseName", $$v)
                    },
                    expression: "form.warehouseName"
                  }
                },
                _vm._l(_vm.warehouseNameList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: item.warehouseName,
                      value: item.warehouseName
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.elementDict.backUpWarehouse.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "backUpWarehouse" }, slot: "backUpWarehouse" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.backUpWarehouse.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.backUpWarehouse.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "backUpWarehouseCmp",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      cache: false,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.backUpWarehouse.writable ||
                        !_vm.backUpWarehouseEnabled,
                      "default-value": _vm.form.backUpWarehouseCmp || "",
                      filterable: "",
                      "static-options": _vm.backUpWarehouseCompanyList,
                      placeholder: !_vm.backUpWarehouseEnabled
                        ? _vm.$t("SeaExport.PleaseSelectBackUpWarehouse")
                        : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.backUpWarehouseCmpChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.agentInformation &&
          _vm.elementDict.agentInformation.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "agentInformation" },
                  slot: "agentInformation"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.agentInformation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.agentInformation.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-textarea", {
                    attrs: {
                      no: "agentInformation",
                      type: "textarea",
                      row: 3,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.agentInformation.writable
                    },
                    model: {
                      value: _vm.form.agentInformation,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "agentInformation", $$v)
                      },
                      expression: "form.agentInformation"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isFba
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ForeignWarehouse") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "overseaWarehouseCode",
                      "select-type":
                        _vm.selectTypeNames.basic_data_OverseaWarehouse,
                      filterable: "",
                      "method-params": { ifFba: false },
                      clearable: false,
                      "tag-name": "countryChineseName",
                      "tag-value": "warehouseCode",
                      "default-value": _vm.form.overseaWarehouseCode,
                      disabled: _vm.readonly
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.overseaWarehouseCode = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.freightTerm.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "freightTerm" }, slot: "freightTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.freightTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.freightTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.freightTerm
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "freightTerm",
                      "select-type":
                        _vm.selectTypeNames.basic_data_ShippingTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.freightTerm,
                      disabled:
                        _vm.readonly || !_vm.elementDict.freightTerm.writable
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.freightTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.freightTermHBL.viewable && !_vm.form.mblOnly
            ? _c(
                "el-form-item",
                { attrs: { slot: "freightTermHBL" }, slot: "freightTermHBL" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.freightTermHBL.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.freightTermHBL.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.freightTermHBL
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "freightTermHBL",
                      "select-type":
                        _vm.selectTypeNames.basic_data_ShippingTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.freightTermHBL,
                      disabled:
                        _vm.readonly || !_vm.elementDict.freightTermHBL.writable
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.freightTermHBL = p.value
                        _vm.pm.freightTermHBLChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.paymentTermMBL.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "paymentTermMBL" }, slot: "paymentTermMBL" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.paymentTermMBL.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.paymentTermMBL.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.paymentTermMBL
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "paymentTermMBL",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.paymentTermMBL.writable ||
                        !_vm.lclslaveEnabled,
                      "select-type": _vm.selectTypeNames.basic_data_PaymentTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.paymentTermMBL
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.paymentTermMBL = p.value
                        _vm.pm.paymentTermMBLChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.placeOfMblPayment.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "placeOfMblPayment" },
                  slot: "placeOfMblPayment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.placeOfMblPayment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.placeOfMblPayment.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.pm.isShowAcPaymentPlaceBL,
                        expression: "!pm.isShowAcPaymentPlaceBL"
                      }
                    ],
                    attrs: {
                      no: "paymentPlaceBL",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.placeOfMblPayment.writable ||
                        !(
                          _vm.isEdit &&
                          (_vm.form.paymentTermMBL === "3P" ||
                            _vm.form.paymentTermMBL === "PP")
                        )
                    },
                    on: {
                      change: function($event) {
                        return _vm.pm.fieldChangeHandler()
                      }
                    },
                    model: {
                      value: _vm.mblDoc.paymentPlaceBL,
                      callback: function($$v) {
                        _vm.$set(_vm.mblDoc, "paymentPlaceBL", $$v)
                      },
                      expression: "mblDoc.paymentPlaceBL"
                    }
                  }),
                  _vm.pm.isShowAcPaymentPlaceBL
                    ? _c("cargo-advance-select", {
                        attrs: {
                          no: "paymentPlaceBL",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.mblDoc.paymentPlaceBL || "",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.placeOfMblPayment.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.mblDoc.paymentPlaceBL = p.value
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.paymentTermHBL.viewable && !_vm.form.mblOnly
            ? _c(
                "el-form-item",
                { attrs: { slot: "paymentTermHBL" }, slot: "paymentTermHBL" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.paymentTermHBL.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.paymentTermHBL.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.paymentTermHBL
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "paymentTermHBL",
                      "select-type": _vm.selectTypeNames.basic_data_PaymentTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.paymentTermHBL,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.paymentTermHBL.writable,
                      "allow-create": true
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.paymentSelectHblChange(p.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.placeOfHblPayment.viewable && !_vm.form.mblOnly
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "placeOfHblPayment" },
                  slot: "placeOfHblPayment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.placeOfHblPayment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.placeOfHblPayment.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.placeOfHblPayment.writable,
                      no: "paymentPlaceBL"
                    },
                    model: {
                      value: _vm.hdoc.paymentPlaceBL,
                      callback: function($$v) {
                        _vm.$set(_vm.hdoc, "paymentPlaceBL", $$v)
                      },
                      expression: "hdoc.paymentPlaceBL"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.bookingTerm.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "bookingTerm" }, slot: "bookingTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.bookingTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.bookingTerm.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      class: _vm.importDifferenceField.bookingTerm
                        ? "red-border"
                        : "",
                      attrs: {
                        no: "bookingTerm",
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.bookingTerm.writable ||
                          !_vm.pm.bookingTermEditable,
                        placeholder: !_vm.pm.bookingTermEditable
                          ? ""
                          : _vm.$t("SeaExport.PleaseSelect"),
                        clearable: false,
                        size: "mini"
                      },
                      model: {
                        value: _vm.form.bookingTerm,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "bookingTerm", $$v)
                        },
                        expression: "form.bookingTerm"
                      }
                    },
                    _vm._l(_vm.bookingTerms, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.incoTerm.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "incoTerm" }, slot: "incoTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.incoTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.incoTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.incoTerm
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "incoTerm",
                      "select-type": _vm.selectTypeNames.basic_data_IncoTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.incoTerm,
                      disabled:
                        _vm.readonly || !_vm.elementDict.incoTerm.writable
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.incoTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.measurements.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "measurements" }, slot: "measurements" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.measurements.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.measurements.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        _vm.readonly || !_vm.elementDict.measurements.writable,
                      no: "measurements",
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.CargoSize"),
                          _vm.form.measurements,
                          function(val) {
                            _vm.form.measurements = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.measurements,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "measurements", $$v)
                      },
                      expression: "form.measurements"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.salePriceRemarks.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "salePriceRemarks" },
                  slot: "salePriceRemarks"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.salePriceRemarks.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.salePriceRemarks.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.salePriceRemarks.writable,
                      no: "salePriceRemarks"
                    },
                    model: {
                      value: _vm.form.salePriceRemarks,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "salePriceRemarks", $$v)
                      },
                      expression: "form.salePriceRemarks"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.businessTags.viewable
            ? _c(
                "div",
                { attrs: { slot: "businessTags" }, slot: "businessTags" },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { margin: "0" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.businessTags.writable,
                        no: "mblOnly"
                      },
                      on: {
                        change: function($event) {
                          return _vm.pm.isMblOnlyChange()
                        }
                      },
                      model: {
                        value: _vm.form.mblOnly,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "mblOnly", $$v)
                        },
                        expression: "form.mblOnly"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.DirectBusiness")) + " ")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { margin: "0" },
                      attrs: {
                        no: "transfering",
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.businessTags.writable ||
                          !_vm.lclslaveEnabled
                      },
                      model: {
                        value: _vm.form.transfering,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "transfering", $$v)
                        },
                        expression: "form.transfering"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Transport")) + " ")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { margin: "0" },
                      attrs: {
                        no: "batch",
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.businessTags.writable ||
                          !_vm.lclslaveEnabled
                      },
                      model: {
                        value: _vm.form.batch,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "batch", $$v)
                        },
                        expression: "form.batch"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.InBatches")) + " ")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { margin: "0" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.businessTags.writable,
                        no: "salePrice"
                      },
                      model: {
                        value: _vm.form.salePrice,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "salePrice", $$v)
                        },
                        expression: "form.salePrice"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.SpecialPrice")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { margin: "0" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.businessTags.writable,
                        no: "allocation"
                      },
                      model: {
                        value: _vm.form.allocation,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "allocation", $$v)
                        },
                        expression: "form.allocation"
                      }
                    },
                    [_vm._v(_vm._s("Allocation") + " ")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.businessTags.writable,
                        no: "availableCabinSpace"
                      },
                      model: {
                        value: _vm.form.availableCabinSpace,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "availableCabinSpace", $$v)
                        },
                        expression: "form.availableCabinSpace"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_AvailableCabinSpace")) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.freeDemurrage.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "freeDemurrage" }, slot: "freeDemurrage" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.freeDemurrage.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.freeDemurrage.label
                    },
                    slot: "label"
                  }),
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled:
                        _vm.readonly || !_vm.elementDict.freeDemurrage.writable,
                      controls: false,
                      no: "freeDemurrage"
                    },
                    model: {
                      value: _vm.form.freeDemurrage,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "freeDemurrage", $$v)
                      },
                      expression: "form.freeDemurrage"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.freeDetention.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "freeDetention" }, slot: "freeDetention" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.freeDetention.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.freeDetention.label
                    },
                    slot: "label"
                  }),
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled:
                        _vm.readonly || !_vm.elementDict.freeDetention.writable,
                      controls: false,
                      no: "freeDetention"
                    },
                    model: {
                      value: _vm.form.freeDetention,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "freeDetention", $$v)
                      },
                      expression: "form.freeDetention"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsAreaApplication.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "customsAreaApplication" },
                  slot: "customsAreaApplication"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsAreaApplication.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsAreaApplication.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.customsAreaApplication.writable,
                      no: "customsAreaApplication"
                    },
                    model: {
                      value: _vm.form.customsAreaApplication,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "customsAreaApplication", $$v)
                      },
                      expression: "form.customsAreaApplication"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.boxOneWay.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "boxOneWay" }, slot: "boxOneWay" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.boxOneWay.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.boxOneWay.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled:
                          _vm.readonly || !_vm.elementDict.boxOneWay.writable,
                        no: "boxOneWay"
                      },
                      model: {
                        value: _vm.form.boxOneWay,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "boxOneWay", $$v)
                        },
                        expression: "form.boxOneWay"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                          value: 0
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_OneWay"),
                          value: 1
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_Circulation"),
                          value: 2
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.seaEq.viewable
            ? _c(
                "template",
                { slot: "seaEq" },
                [
                  _vm.form.containerLoadType === "FCL" ||
                  _vm.form.containerLoadType === "BB" ||
                  _vm.form.containerLoadType === "BCF"
                    ? _c("booking-sea-eq-data-grid", {
                        ref: "bookingSeaEqDataGrid",
                        attrs: {
                          no: "bookingSeaEqDataGrid",
                          value: _vm.seaEqList,
                          "container-load-type": _vm.form.containerLoadType,
                          "is-edit":
                            _vm.isEdit && _vm.elementDict.seaEq.writable,
                          job: _vm.form,
                          "slave-customs-declaration-enable":
                            _vm.slaveCustomsDeclarationEnable
                        },
                        on: { eqQuantityChange: _vm.eqQuantityChangeHandler }
                      })
                    : _vm._e(),
                  _vm.form.containerLoadType === "BULK"
                    ? _c("booking-bulk-data-grid", {
                        attrs: {
                          no: "BULK",
                          value: _vm.cargoBulkDetailList,
                          context: _vm.context,
                          "job-uuid": _vm.form.uuid,
                          "is-edit":
                            _vm.isEdit && _vm.elementDict.seaEq.writable
                        }
                      })
                    : _vm._e(),
                  _vm.form.containerLoadType === "SPA"
                    ? _c("booking-special-data-grid", {
                        attrs: {
                          no: "SPA",
                          value: _vm.seaEqList,
                          "is-edit":
                            _vm.isEdit && _vm.elementDict.seaEq.writable,
                          job: _vm.form
                        },
                        on: { eqQuantityChange: _vm.eqQuantityChangeHandler }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.characteristic &&
          _vm.elementDict.characteristic.viewable &&
          _vm.showCharacteristic
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-around"
                  },
                  attrs: { slot: "characteristic" },
                  slot: "characteristic"
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { margin: "0" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.characteristic.writable,
                        no: "electric"
                      },
                      model: {
                        value: _vm.form.electric,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "electric", $$v)
                        },
                        expression: "form.electric"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Electric")) + " ")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { margin: "0" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.characteristic.writable,
                        no: "magnetic"
                      },
                      model: {
                        value: _vm.form.magnetic,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "magnetic", $$v)
                        },
                        expression: "form.magnetic"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Magnetic")) + " ")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { margin: "0" },
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.characteristic.writable,
                        no: "powder"
                      },
                      model: {
                        value: _vm.form.powder,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "powder", $$v)
                        },
                        expression: "form.powder"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Powder")) + " ")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.characteristic.writable,
                        no: "liquid"
                      },
                      model: {
                        value: _vm.form.liquid,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "liquid", $$v)
                        },
                        expression: "form.liquid"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Liquid")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.quantityConsignActual.viewable,
                  expression: "elementDict.quantityConsignActual.viewable"
                }
              ],
              attrs: { slot: "quantityConsignActual" },
              slot: "quantityConsignActual"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.quantityConsignActual.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.quantityConsignActual.label
                },
                slot: "label"
              }),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("auto-number-input", {
                    class: _vm.importDifferenceField.quantityContract
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "quantityContract",
                      precision: 0,
                      min: 0,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.quantityConsignActual.writable ||
                        !_vm.isJydEditJobFields
                    },
                    on: {
                      change: function($event) {
                        _vm.pm.jobContractQwcChange(1)
                        _vm.calcEstVolumetricAndChargeWeight()
                      }
                    },
                    model: {
                      value: _vm.form.quantityContract,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "quantityContract", $$v)
                      },
                      expression: "form.quantityContract"
                    }
                  }),
                  _c("span", { staticStyle: { padding: "0 2px" } }, [
                    _vm._v("/")
                  ]),
                  _c("auto-number-input", {
                    ref: "quantityActual",
                    class: _vm.importDifferenceField.quantityActual
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "quantityActual",
                      precision: 0,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.quantityConsignActual.writable ||
                        _vm.pm.billChargeFlag ||
                        !_vm.isJydEditJobFields,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        _vm.quantityActualChange()
                        _vm.pm.syncQwcToPoItems(
                          _vm.form.quantityActual || 0,
                          null,
                          null
                        )
                      }
                    },
                    model: {
                      value: _vm.form.quantityActual,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "quantityActual", $$v)
                      },
                      expression: "form.quantityActual"
                    }
                  }),
                  _c("span", [_vm._v("PCS")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.weightConsignActual.viewable,
                  expression: "elementDict.weightConsignActual.viewable"
                }
              ],
              attrs: { slot: "weightConsignActual" },
              slot: "weightConsignActual"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.weightConsignActual.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.weightConsignActual.label
                },
                slot: "label"
              }),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("auto-number-input", {
                    class: _vm.importDifferenceField.weightContract
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "weightContract",
                      precision: 3,
                      min: 0,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.weightConsignActual.writable ||
                        !_vm.isJydEditJobFields
                    },
                    on: {
                      change: function($event) {
                        _vm.weightContractChange()
                        _vm.calcEstVolumetricAndChargeWeight()
                      }
                    },
                    model: {
                      value: _vm.form.weightContract,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "weightContract", $$v)
                      },
                      expression: "form.weightContract"
                    }
                  }),
                  _c("span", { staticStyle: { padding: "0 2px" } }, [
                    _vm._v("/")
                  ]),
                  _c("auto-number-input", {
                    ref: "weightActual",
                    class: _vm.importDifferenceField.weightActual
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "weightActual",
                      precision: 3,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.weightConsignActual.writable ||
                        _vm.pm.billChargeFlag ||
                        !_vm.isJydEditJobFields,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        _vm.weightActualChange()
                        _vm.pm.syncQwcToPoItems(
                          null,
                          _vm.form.weightActual || 0,
                          null
                        )
                      }
                    },
                    model: {
                      value: _vm.form.weightActual,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "weightActual", $$v)
                      },
                      expression: "form.weightActual"
                    }
                  }),
                  _c("span", [_vm._v("KGS")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.cubageConsignActual.viewable,
                  expression: "elementDict.cubageConsignActual.viewable"
                }
              ],
              attrs: { slot: "cubageConsignActual" },
              slot: "cubageConsignActual"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.cubageConsignActual.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.cubageConsignActual.label
                },
                slot: "label"
              }),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("auto-number-input", {
                    class: _vm.importDifferenceField.cubageContract
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "cubageContract",
                      precision: 3,
                      min: 0,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.cubageConsignActual.writable ||
                        !_vm.isJydEditJobFields
                    },
                    on: {
                      change: function($event) {
                        _vm.cubageContractChange()
                        _vm.calcEstVolumetricAndChargeWeight()
                      }
                    },
                    model: {
                      value: _vm.form.cubageContract,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cubageContract", $$v)
                      },
                      expression: "form.cubageContract"
                    }
                  }),
                  _c("span", { staticStyle: { padding: "0 2px" } }, [
                    _vm._v("/")
                  ]),
                  _c("auto-number-input", {
                    ref: "cubageActual",
                    class: _vm.importDifferenceField.cubageActual
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "cubageActual",
                      precision: 3,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.cubageConsignActual.writable ||
                        !_vm.cubageActualEnabled ||
                        !_vm.isJydEditJobFields,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        _vm.cubageActualChange()
                        _vm.pm.syncQwcToPoItems(
                          null,
                          null,
                          _vm.form.cubageActual || 0
                        )
                      }
                    },
                    model: {
                      value: _vm.form.cubageActual,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cubageActual", $$v)
                      },
                      expression: "form.cubageActual"
                    }
                  }),
                  _c("span", [_vm._v("CBM")])
                ],
                1
              )
            ],
            1
          ),
          _vm.isFba
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.VolumetricWeightConsignActual")
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("auto-number-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          no: "volumetricWeightContract",
                          precision: 3,
                          min: 0
                        },
                        on: {
                          change: function($event) {
                            return _vm.calcEstVolumetricAndChargeWeight(
                              _vm.form.volumetricWeightContract
                            )
                          }
                        },
                        model: {
                          value: _vm.form.volumetricWeightContract,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "volumetricWeightContract", $$v)
                          },
                          expression: "form.volumetricWeightContract"
                        }
                      }),
                      _c("span", { staticStyle: { padding: "0 2px" } }, [
                        _vm._v("/")
                      ]),
                      _c("auto-number-input", {
                        ref: "volumetricWeight",
                        attrs: {
                          disabled: _vm.readonly,
                          no: "volumetricWeight",
                          precision: 3,
                          min: 0
                        },
                        on: { change: _vm.changeVolumetricWeight },
                        model: {
                          value: _vm.form.volumetricWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "volumetricWeight", $$v)
                          },
                          expression: "form.volumetricWeight"
                        }
                      }),
                      _c("span", [_vm._v("KGS")])
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.isFba
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.ChargeWeightConsignActual")
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("auto-number-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          no: "chargeWeightContract",
                          precision: 3,
                          min: 0
                        },
                        model: {
                          value: _vm.form.chargeWeightContract,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "chargeWeightContract", $$v)
                          },
                          expression: "form.chargeWeightContract"
                        }
                      }),
                      _c("span", { staticStyle: { padding: "0 2px" } }, [
                        _vm._v("/")
                      ]),
                      _c("auto-number-input", {
                        ref: "chargeWeight",
                        attrs: {
                          disabled: _vm.readonly,
                          no: "chargeWeight",
                          precision: 3,
                          min: 0
                        },
                        on: { change: _vm.changeChargeWeight },
                        model: {
                          value: _vm.form.chargeWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "chargeWeight", $$v)
                          },
                          expression: "form.chargeWeight"
                        }
                      }),
                      _c("span", [_vm._v("KGS")])
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.isFba
            ? _c("el-form-item", { attrs: { "label-width": "0" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-around"
                    }
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: {
                          "margin-right": "10px",
                          "margin-left": "20px"
                        },
                        attrs: { disabled: _vm.readonly },
                        model: {
                          value: _vm.fbaJob.electric,
                          callback: function($$v) {
                            _vm.$set(_vm.fbaJob, "electric", $$v)
                          },
                          expression: "fbaJob.electric"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.WithElectricity")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: { disabled: _vm.readonly },
                        model: {
                          value: _vm.fbaJob.magnetic,
                          callback: function($$v) {
                            _vm.$set(_vm.fbaJob, "magnetic", $$v)
                          },
                          expression: "fbaJob.magnetic"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.WithMagnetism")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: { disabled: _vm.readonly },
                        model: {
                          value: _vm.fbaJob.powdery,
                          callback: function($$v) {
                            _vm.$set(_vm.fbaJob, "powdery", $$v)
                          },
                          expression: "fbaJob.powdery"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Powder")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: { disabled: _vm.readonly },
                        model: {
                          value: _vm.fbaJob.liquid,
                          callback: function($$v) {
                            _vm.$set(_vm.fbaJob, "liquid", $$v)
                          },
                          expression: "fbaJob.liquid"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Liquid")))]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.elementDict.insideQuantitySize.viewable &&
          _vm.form.containerLoadType === "BULK"
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "insideQuantitySize" },
                  slot: "insideQuantitySize"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.insideQuantitySize.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.insideQuantitySize.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.insideQuantitySize.writable,
                      no: "insideQuantitySize",
                      precision: 0
                    },
                    model: {
                      value: _vm.form.insideQuantitySize,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "insideQuantitySize", $$v)
                      },
                      expression: "form.insideQuantitySize"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.packing.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "packing" }, slot: "packing" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.packing.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.packing.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-packing-select", {
                    class: _vm.importDifferenceField.packing
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "packing",
                      "default-value": _vm.form.packing,
                      disabled:
                        _vm.readonly || !_vm.elementDict.packing.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.form.packing = p.value
                        _vm.pm.txtPackingChangeHandler()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.insideQuantity.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "insideQuantity" }, slot: "insideQuantity" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.insideQuantity.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.insideQuantity.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    class: _vm.importDifferenceField.insideQuantity
                      ? "red-border"
                      : "",
                    attrs: {
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.insideQuantity.writable,
                      no: "insideQuantity",
                      precision: 0,
                      min: 0
                    },
                    on: {
                      valCallBack: function(val) {
                        _vm.form.insideQuantity = val
                      }
                    },
                    model: {
                      value: _vm.form.insideQuantity,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "insideQuantity", $$v)
                      },
                      expression: "form.insideQuantity"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.insidePacking.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "insidePacking" }, slot: "insidePacking" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.insidePacking.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.insidePacking.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-packing-select", {
                    attrs: {
                      no: "insidePacking",
                      "default-value": _vm.form.insidePacking,
                      disabled:
                        _vm.readonly || !_vm.elementDict.insidePacking.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.form.insidePacking = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.chargeWeight.viewable && !_vm.isFba
            ? _c(
                "el-form-item",
                { attrs: { slot: "chargeWeight" }, slot: "chargeWeight" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.chargeWeight.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.chargeWeight.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("auto-number-input", {
                        class: _vm.importDifferenceField.chargeWeight
                          ? "red-border"
                          : "",
                        staticStyle: { flex: "1" },
                        attrs: {
                          no: "chargeWeight",
                          precision: 3,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.chargeWeight.writable ||
                            !_vm.chargeWeightEnabled,
                          min: 0
                        },
                        on: {
                          change: function($event) {
                            return _vm.pm.chargeWeightChange()
                          }
                        },
                        model: {
                          value: _vm.form.chargeWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "chargeWeight", $$v)
                          },
                          expression: "form.chargeWeight"
                        }
                      }),
                      _c("span", [_vm._v("M/T")])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoEnglishName.viewable
            ? _c(
                "template",
                { slot: "cargoEnglishName" },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.isEdit &&
                            _vm.elementDict.cargoEnglishName.writable,
                          expression:
                            "isEdit && elementDict.cargoEnglishName.writable"
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "Copy2", type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.transcribeDialog.visible = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Copy2")) + " ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoEnglishName.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoEnglishName.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "special-character-tip",
                        {
                          attrs: {
                            texts: _vm.specialCharCheck.cargoEnglishName
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { position: "relative" } },
                            [
                              _c("cargo-textarea", {
                                ref: "cargoTextarea1",
                                class: _vm.importDifferenceField
                                  .cargoEnglishName
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  no: "cargoEnglishName",
                                  type: "textarea",
                                  rows: 5,
                                  disabled:
                                    !_vm.isEdit ||
                                    !_vm.elementDict.cargoEnglishName.writable,
                                  "wrap-symbol": "r",
                                  "auto-half-word": "",
                                  "auto-uppercase": _vm.isUppercaseByConfig
                                },
                                on: { change: _vm.onCargoEnglishNameChange },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.elementDict.cargoEnglishName.label,
                                      _vm.form.cargoEnglishName,
                                      function(val) {
                                        _vm.pm.cargoEnglishNameChangeHandler(
                                          val
                                        )
                                      },
                                      _vm.isUppercaseByConfig,
                                      {
                                        autoHalfWord: true,
                                        autoUppercase: _vm.isUppercaseByConfig
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.cargoEnglishName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cargoEnglishName", $$v)
                                  },
                                  expression: "form.cargoEnglishName"
                                }
                              }),
                              _c("char-count", {
                                attrs: { value: _vm.form.cargoEnglishName }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.mark.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "mark" }, slot: "mark" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.mark.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.mark.label },
                    slot: "label"
                  }),
                  _c(
                    "special-character-tip",
                    { attrs: { texts: _vm.specialCharCheck.mark } },
                    [
                      _c(
                        "div",
                        { staticStyle: { position: "relative" } },
                        [
                          _c("cargo-textarea", {
                            ref: "cargoTextarea2",
                            class: _vm.importDifferenceField.mark
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "mark",
                              type: "textarea",
                              rows: 5,
                              "wrap-symbol": "r",
                              "auto-half-word": "",
                              "auto-uppercase": _vm.isUppercaseByConfig,
                              disabled:
                                !_vm.isEdit || !_vm.elementDict.mark.writable
                            },
                            on: { change: _vm.onMarkChange },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.elementDict.mark.label,
                                  _vm.form.mark,
                                  function(val) {
                                    _vm.pm.markChangeHandler(val)
                                  },
                                  _vm.isUppercaseByConfig,
                                  {
                                    autoHalfWord: true,
                                    autoUppercase: _vm.isUppercaseByConfig
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mark", $$v)
                              },
                              expression: "form.mark"
                            }
                          }),
                          _c("char-count", { attrs: { value: _vm.form.mark } })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.hsCode.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "hsCode" }, slot: "hsCode" },
                [
                  _c(
                    "div",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.hsCode.isRequire ? "blue" : "",
                        attrs: { label: _vm.elementDict.hsCode.label }
                      }),
                      _c("br"),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isEdit && _vm.elementDict.hsCode.writable,
                              expression:
                                "isEdit && elementDict.hsCode.writable"
                            }
                          ],
                          attrs: { no: "Search", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.showHsCodeSearchDialog(
                                _vm.$t("Message.SelectHsCode"),
                                function(val) {
                                  _vm.pm.hsCodeChangeHandler(val.code)
                                }
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Search")) + " ")]
                      )
                    ],
                    1
                  ),
                  _c("el-input", {
                    class: _vm.importDifferenceField.hsCode ? "red-border" : "",
                    attrs: {
                      disabled:
                        _vm.readonly || !_vm.elementDict.hsCode.writable,
                      no: "hsCode",
                      type: "textarea",
                      rows: 5
                    },
                    on: {
                      change: function(val) {
                        _vm.pm.hsCodeChangeHandler(val)
                      }
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.elementDict.hsCode.label,
                          _vm.form.hsCode,
                          function(val) {
                            _vm.pm.hsCodeChangeHandler(val)
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.hsCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "hsCode", $$v)
                      },
                      expression: "form.hsCode"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoChineseName.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cargoChineseName" },
                  slot: "cargoChineseName"
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoChineseName.isRequire
                          ? "blue"
                          : "",
                        attrs: { label: _vm.elementDict.cargoChineseName.label }
                      }),
                      _c("br"),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isEdit &&
                                _vm.elementDict.cargoChineseName.writable,
                              expression:
                                "isEdit && elementDict.cargoChineseName.writable"
                            }
                          ],
                          attrs: {
                            no: "ChineseDescriptionOfGoods",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              _vm.showHsCodeSearchDialog(
                                _vm.$t("Message.SelectCargoChineseName"),
                                function(p) {
                                  return (_vm.form.cargoChineseName =
                                    p.commodityName)
                                }
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Search")) + " ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { position: "relative" } },
                    [
                      _c("cargo-textarea", {
                        class: _vm.importDifferenceField.cargoChineseName
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "cargoChineseName",
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.cargoChineseName.writable,
                          type: "textarea",
                          rows: 5,
                          "auto-uppercase": false,
                          "auto-half-word": false,
                          "wrap-symbol": "r"
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.cargoChineseName.label,
                              _vm.form.cargoChineseName,
                              function(val) {
                                _vm.form.cargoChineseName = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.cargoChineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cargoChineseName", $$v)
                          },
                          expression: "form.cargoChineseName"
                        }
                      }),
                      _c("char-count", {
                        attrs: { value: _vm.form.cargoChineseName }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.elementDict.cargoCode.viewable
            ? _c(
                "template",
                { slot: "cargoCode" },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "custom" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.cargoCode
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "cargoCode",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoInformation,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.cargoCode.writable ||
                            _vm.canEditInternalDelegatedJobField,
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.form.cargoCode,
                          "allow-create": false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.cargoCodeChange(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        class: _vm.importDifferenceField.cargoName
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "cargoName",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.cargoCode.writable ||
                            !(_vm.isEdit && _vm.form.cargoCode) ||
                            _vm.canEditInternalDelegatedJobField
                        },
                        model: {
                          value: _vm.form.cargoName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cargoName", $$v)
                          },
                          expression: "form.cargoName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.salesCompany.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "salesCompany" }, slot: "salesCompany" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.salesCompany.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.salesCompany.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    class: _vm.importDifferenceField.salesOffice
                      ? "red-border"
                      : "",
                    attrs: { value: _vm.txtSalesOffice, disabled: true }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.sales.viewable,
                  expression: "elementDict.sales.viewable"
                }
              ],
              attrs: { slot: "sales" },
              slot: "sales"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.sales.isRequire ? "blue" : "",
                attrs: { slot: "label", label: _vm.elementDict.sales.label },
                slot: "label"
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between"
                  }
                },
                [
                  _c("cargo-user-select", {
                    ref: "sales",
                    class: _vm.importDifferenceField.sales ? "red-border" : "",
                    staticStyle: { flex: "1" },
                    attrs: {
                      no: "sales",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.sales.writable ||
                        !_vm.saleEnabled,
                      "method-params": {
                        officeId: _vm.salesOfficeCheck
                          ? _vm.$store.getters.currentOfficeId
                          : "",
                        category: "role",
                        shape: "sales"
                      },
                      "default-value": _vm.form.sales || "",
                      "static-options": _vm.salesList,
                      placeholder: _vm.salesPrompt,
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.form.salesRecord = p.value
                        _vm.pm.salesChangeHandler(p)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: { no: "provisioned", disabled: true },
                      model: {
                        value: _vm.form.provisioned,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "provisioned", $$v)
                        },
                        expression: "form.provisioned"
                      }
                    },
                    [_vm._v(_vm._s(_vm.fieldDict.provisioned.label) + " ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.elementDict.cargoSalesId.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoSalesId" }, slot: "cargoSalesId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoSalesId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoSalesId.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    class: _vm.importDifferenceField.cargoSalesId
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "cargoSalesId",
                      "method-params": {
                        category: "role",
                        shape: "salesOfGoods"
                      },
                      "default-value": _vm.form.cargoSalesId || "",
                      disabled:
                        _vm.readonly || !_vm.elementDict.cargoSalesId.writable,
                      "merge-load": true,
                      "static-options": _vm.cargoSalesList
                    },
                    on: {
                      change: function(p) {
                        _vm.form.cargoSalesId = p.value
                        _vm.pm.cargoSalesChargeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.salesDepartment.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "salesDepartment" }, slot: "salesDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.salesDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.salesDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-new-select", {
                    class: _vm.importDifferenceField.salesDepartment
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "salesOffice",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.salesDepartment.writable ||
                        !_vm.form.sales,
                      "sales-id": Number(_vm.form.sales),
                      "office-id": _vm.form.salesOffice,
                      enables: true,
                      "department-id": Number(_vm.form.salesDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.salesDepartment = p.value
                        _vm.pm.departmentChargeHandler()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.opOffice.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "opOffice" }, slot: "opOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.opOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.opOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-office-select", {
                    class: _vm.importDifferenceField.opOffice
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "opOffice",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.opOffice.writable ||
                        (!_vm.isRegionalCommission &&
                          _vm.pm.isEntrustOrder(true)) ||
                        _vm.opOfficeDisabled,
                      "is-regional-commission": _vm.isRegionalCommission,
                      "office-id": Number(_vm.form.opOffice)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.opOffice = p.value
                        _vm.form.opDepartment = 0
                        _vm.pm.opOfficeChangeHandler()
                        _vm.contractRuleFieldChange(
                          _vm.form.customerId,
                          _vm.form.designationAgent
                        )
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.opDepartment.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "opDepartment" }, slot: "opDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.opDepartment.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.opDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    class: _vm.importDifferenceField.opDepartment
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "opDepartment",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.opDepartment.writable ||
                        _vm.pm.isWithinCloseAccountDate,
                      "office-id": Number(_vm.form.opOffice),
                      enables: true,
                      "department-id": Number(_vm.form.opDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.opDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.op.viewable,
                  expression: "elementDict.op.viewable"
                }
              ],
              attrs: { slot: "op" },
              slot: "op"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.op.isRequire ? "blue" : "",
                attrs: { slot: "label", label: _vm.elementDict.op.label },
                slot: "label"
              }),
              _c("cargo-user-select", {
                ref: "op",
                class: _vm.importDifferenceField.op ? "red-border" : "",
                attrs: {
                  no: "op",
                  disabled:
                    _vm.readonly ||
                    !_vm.elementDict.op.writable ||
                    !_vm.opEabled,
                  "method-params": {
                    officeId: _vm.form.opOffice,
                    category: "role",
                    shape: "op"
                  },
                  "default-value": _vm.form.op || "",
                  "merge-load": true,
                  "static-options": _vm.userPortRoleData.op
                },
                on: {
                  change: function(p) {
                    _vm.form.op = p.value
                    _vm.pm.txtOPChangeHandler(p)
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.csrOffice.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "csrOffice" }, slot: "csrOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csrOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.csrOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-office-select", {
                    class: _vm.importDifferenceField.csrOffice
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "csrOffice",
                      disabled: true,
                      "office-id": Number(_vm.form.csrOffice)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.csrOffice = p.value
                        _vm.form.csrDepartment = 0
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csrDepartment.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "csrDepartment" }, slot: "csrDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csrDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.csrDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    class: _vm.importDifferenceField.csrDepartment
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "csrDepartment",
                      "office-id": Number(_vm.form.csrOffice),
                      enables: true,
                      "department-id": Number(_vm.form.csrDepartment),
                      disabled:
                        _vm.readonly || !_vm.elementDict.csrDepartment.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.form.csrDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.csr.viewable,
                  expression: "elementDict.csr.viewable"
                }
              ],
              attrs: { slot: "csr" },
              slot: "csr"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.csr.isRequire ? "blue" : "",
                attrs: { slot: "label", label: _vm.elementDict.csr.label },
                slot: "label"
              }),
              _c("cargo-user-select", {
                ref: "csr",
                class: _vm.importDifferenceField.csr ? "red-border" : "",
                attrs: {
                  no: "csr",
                  "method-params": {
                    officeId:
                      _vm.pm.isEntrustOrder || _vm.form.salesOffice === 1
                        ? _vm.form.opOffice
                        : _vm.form.salesOffice,
                    category: "role",
                    shape: "csr"
                  },
                  "default-value": _vm.form.csr || "",
                  disabled: _vm.readonly || !_vm.elementDict.csr.writable,
                  "merge-load": true,
                  "static-options": _vm.userPortRoleData.csr
                },
                on: {
                  change: function(p) {
                    _vm.pm.csrChangeHandler(p)
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.siteOP.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "siteOP" }, slot: "siteOP" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.siteOP.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.siteOP.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      "method-params": {
                        officeId: _vm.form.opOffice,
                        category: "role",
                        shape: "siteOp"
                      },
                      "default-value": _vm.form.siteOP || "",
                      disabled:
                        _vm.readonly || !_vm.elementDict.siteOP.writable,
                      "static-options": _vm.userPortRoleData.siteOp
                    },
                    on: {
                      change: function(p) {
                        _vm.JobUtils.siteOpChangeHandler(_vm.form, p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.overseaOp.viewable,
                  expression: "elementDict.overseaOp.viewable"
                }
              ],
              attrs: { slot: "overseaOp" },
              slot: "overseaOp"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.overseaOp.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.overseaOp.label
                },
                slot: "label"
              }),
              _c("cargo-user-select", {
                ref: "overseaOp",
                attrs: {
                  no: "overseaOp",
                  "default-value": _vm.form.overseaOp || "",
                  disabled: _vm.readonly || !_vm.elementDict.overseaOp.writable,
                  "method-params": { category: "role", shape: "overseaOp" },
                  "static-options": _vm.isHC
                    ? null
                    : _vm.userPortRoleData.overseaOp ||
                      _vm.overseaAgentUsersList,
                  "merge-load": true
                },
                on: {
                  change: function(p) {
                    _vm.form.overseaOp = p.value
                    _vm.pm.overseaOpChangeHandler(p)
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.dcOffice.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "dcOffice" }, slot: "dcOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dcOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dcOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-office-select", {
                    class: _vm.importDifferenceField.dcOffice
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "dcOffice",
                      disabled: true,
                      "office-id": Number(_vm.form.dcOffice)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.dcOffice = p.value
                        _vm.form.dcDepartment = 0 /* ;pm.dcOfficeChangeHandler() */
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dcDepartment.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "dcDepartment" }, slot: "dcDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dcDepartment.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dcDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    class: _vm.importDifferenceField.dcDepartment
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "dcDepartment",
                      "office-id": Number(_vm.form.dcOffice),
                      enables: true,
                      "department-id": Number(_vm.form.dcDepartment),
                      disabled:
                        _vm.readonly || !_vm.elementDict.dcDepartment.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.form.dcDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.dc.viewable,
                  expression: "elementDict.dc.viewable"
                }
              ],
              attrs: { slot: "dc" },
              slot: "dc"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.dc.isRequire ? "blue" : "",
                attrs: { slot: "label", label: _vm.elementDict.dc.label },
                slot: "label"
              }),
              _c("cargo-user-select", {
                ref: "dc",
                class: _vm.importDifferenceField.dc ? "red-border" : "",
                attrs: {
                  no: "dc",
                  "method-params": {
                    officeId: _vm.form.opOffice,
                    category: "role",
                    shape: "doc"
                  },
                  "default-value": _vm.form.dc || "",
                  disabled: _vm.readonly || !_vm.elementDict.dc.writable,
                  "merge-load": true,
                  "static-options": _vm.userPortRoleData.doc
                },
                on: {
                  change: function(p) {
                    _vm.pm.dcChangeHandler(p)
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.plannerOffice &&
          _vm.elementDict.plannerOffice.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "plannerOffice" }, slot: "plannerOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.plannerOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.plannerOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-office-select", {
                    class: _vm.importDifferenceField.plannerOffice
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "plannerOffice",
                      disabled: true,
                      "office-id": Number(_vm.form.plannerOffice)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.plannerOffice = p.value
                        _vm.form.plannerDepartment = 0
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.plannerDepartment &&
          _vm.elementDict.plannerDepartment.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "plannerDepartment" },
                  slot: "plannerDepartment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.plannerDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.plannerDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    class: _vm.importDifferenceField.plannerDepartment
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "plannerDepartment",
                      "office-id": Number(_vm.form.plannerOffice),
                      enables: true,
                      "department-id": Number(_vm.form.plannerDepartment),
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.plannerDepartment.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.form.plannerDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.planner.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "planner" }, slot: "planner" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.planner.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.planner.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    class: _vm.importDifferenceField.planner
                      ? "red-border"
                      : "",
                    attrs: {
                      no: "planner",
                      "method-params": {
                        officeId: _vm.form.opOffice,
                        category: "role",
                        shape: "seaLine"
                      },
                      "default-value": _vm.form.planner || "",
                      disabled:
                        _vm.readonly || !_vm.elementDict.planner.writable,
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.seaLine
                    },
                    on: {
                      change: function(p) {
                        _vm.form.planner = p.value
                        _vm.pm.txtPlannerChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.elementDict.userDefinedRoleId1.viewable &&
                    _vm.isAddUserDefinedRoles,
                  expression:
                    "elementDict.userDefinedRoleId1.viewable && isAddUserDefinedRoles"
                }
              ],
              attrs: { slot: "userDefinedRoleId1" },
              slot: "userDefinedRoleId1"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.userDefinedRoleId1.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.userDefinedRoleId1.label
                },
                slot: "label"
              }),
              _c("cargo-user-select", {
                ref: "userDefinedRoleId1",
                attrs: {
                  no: "userDefinedRoleId1",
                  "method-params": {
                    officeId: _vm.$store.getters.currentOfficeId,
                    category: "role",
                    shape: "userDefinedRole1"
                  },
                  "default-value": _vm.form.userDefinedRoleId1 || "",
                  disabled:
                    _vm.readonly ||
                    !_vm.elementDict.userDefinedRoleId1.writable,
                  "merge-load": true,
                  "static-options": _vm.userPortRoleData.userDefinedRole1
                },
                on: {
                  change: function(p) {
                    _vm.pm.userDefinedRoleId1Handler(p)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.elementDict.userDefinedRoleId2.viewable &&
                    _vm.isAddUserDefinedRoles,
                  expression:
                    "elementDict.userDefinedRoleId2.viewable && isAddUserDefinedRoles"
                }
              ],
              attrs: { slot: "userDefinedRoleId2" },
              slot: "userDefinedRoleId2"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.userDefinedRoleId2.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.userDefinedRoleId2.label
                },
                slot: "label"
              }),
              _c("cargo-user-select", {
                ref: "userDefinedRoleId2",
                attrs: {
                  no: "userDefinedRoleId2",
                  "method-params": {
                    officeId: _vm.$store.getters.currentOfficeId,
                    category: "role",
                    shape: "userDefinedRole2"
                  },
                  "default-value": _vm.form.userDefinedRoleId2 || "",
                  disabled:
                    _vm.readonly ||
                    !_vm.elementDict.userDefinedRoleId2.writable,
                  "merge-load": true,
                  "static-options": _vm.userPortRoleData.userDefinedRole2
                },
                on: {
                  change: function(p) {
                    _vm.pm.userDefinedRoleId2Handler(p)
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.userDefinedRoleId3 &&
          _vm.elementDict.userDefinedRoleId3.viewable &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId3" },
                  slot: "userDefinedRoleId3"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId3.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId3.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId3",
                    attrs: {
                      no: "userDefinedRoleId3",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole3"
                      },
                      "default-value": _vm.form.userDefinedRoleId3 || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.userDefinedRole3
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId3Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId4 &&
          _vm.elementDict.userDefinedRoleId4.viewable &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId4" },
                  slot: "userDefinedRoleId4"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId4.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId4.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId4",
                    attrs: {
                      no: "userDefinedRoleId4",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole4"
                      },
                      "default-value": _vm.form.userDefinedRoleId4 || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.userDefinedRole4
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId4Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId5 &&
          _vm.elementDict.userDefinedRoleId5.viewable &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId5" },
                  slot: "userDefinedRoleId5"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId5.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId5.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId5",
                    attrs: {
                      no: "userDefinedRoleId5",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole5"
                      },
                      "default-value": _vm.form.userDefinedRoleId5 || "",
                      disabled: _vm.readonly,
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId5Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId6 &&
          _vm.elementDict.userDefinedRoleId6.viewable &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId6" },
                  slot: "userDefinedRoleId6"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId6.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId6.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId6",
                    attrs: {
                      no: "userDefinedRoleId6",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole6"
                      },
                      "default-value": _vm.form.userDefinedRoleId6 || "",
                      disabled: _vm.readonly,
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId6Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId7 &&
          _vm.elementDict.userDefinedRoleId7.viewable &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId7" },
                  slot: "userDefinedRoleId7"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId7.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId7.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId7",
                    attrs: {
                      no: "userDefinedRoleId7",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole7"
                      },
                      "default-value": _vm.form.userDefinedRoleId7 || "",
                      disabled: _vm.readonly,
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId7Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId8 &&
          _vm.elementDict.userDefinedRoleId8.viewable &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId8" },
                  slot: "userDefinedRoleId8"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId8.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId8.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId8",
                    attrs: {
                      no: "userDefinedRoleId8",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole8"
                      },
                      "default-multiple-value": _vm.toNumArray(
                        _vm.form.userDefinedRoleId8
                      ),
                      disabled: _vm.readonly,
                      multiple: true,
                      "merge-load": true,
                      placeholder: _vm.readonly ? " " : ""
                    },
                    on: {
                      change: function(p) {
                        _vm.form.userDefinedRoleId8 = _vm.toTxt(p.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("special-requests-grid", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.elementDict.satisfiedRequests.viewable,
                expression: "elementDict.satisfiedRequests.viewable"
              }
            ],
            ref: "selectedSpecialRequest",
            staticStyle: { "margin-bottom": "5px" },
            attrs: {
              slot: "satisfiedRequests",
              no: "satisfiedRequests",
              "is-edit":
                _vm.isEdit && _vm.elementDict.satisfiedRequests.writable,
              "customer-id": Number(_vm.form.customerId),
              lob: _vm.form.lob,
              job: _vm.form
            },
            slot: "satisfiedRequests",
            model: {
              value: _vm.form.satisfiedRequests,
              callback: function($$v) {
                _vm.$set(_vm.form, "satisfiedRequests", $$v)
              },
              expression: "form.satisfiedRequests"
            }
          }),
          _vm.elementDict.operationContent.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "operationContent" },
                  slot: "operationContent"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.operationContent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.operationContent.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.form.operationContent,
                        placement: "left"
                      }
                    },
                    [
                      _c("div", {
                        attrs: { slot: "content" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.form.operationContent
                              ? _vm.form.operationContent.replace(
                                  /[\n]/g,
                                  "</br>"
                                )
                              : _vm.$t("SeaExport.NoData")
                          )
                        },
                        slot: "content"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "operationContent",
                          value: _vm.form.operationContent,
                          disabled:
                            (_vm.lockJobByPrintHblZb ? false : _vm.readonly) ||
                            !_vm.elementDict.operationContent.writable,
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t(
                                "SeaExport.DoubleClickToAddOperationRequirements"
                              ),
                          type: "textarea",
                          rows: 4
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.selectOperationReqDialog.value =
                              _vm.form.operationContent
                            _vm.selectOperationReqDialog.visible =
                              _vm.isEdit || _vm.lockJobByPrintHblZb
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.operationTips.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "operationTips" }, slot: "operationTips" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.operationTips.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.operationTips.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        (_vm.lockJobByPrintHblZb ? false : _vm.readonly) ||
                        !_vm.elementDict.operationTips.writable,
                      no: "operationTips",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.OperationTips"),
                          _vm.form.operationTips,
                          function(val) {
                            _vm.form.operationTips = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.operationTips,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "operationTips", $$v)
                      },
                      expression: "form.operationTips"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.surchargeTerms.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "surchargeTerms" }, slot: "surchargeTerms" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.surchargeTerms.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.surchargeTerms.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "txtSurchargeTerms",
                      value: _vm.txtSurchargeTerms,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.surchargeTerms.writable,
                      placeholder: _vm.readonly
                        ? ""
                        : _vm.$t("SeaExport.DoubleClickToAddExtraChargeClause"),
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.selectSurchargeTermsDialog.rowData =
                          _vm.form.surchargeTerms
                        _vm.selectSurchargeTermsDialog.visible = true
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.prePortPlanner &&
          _vm.elementDict.prePortPlanner.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "prePortPlanner" }, slot: "prePortPlanner" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.prePortPlanner.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.prePortPlanner.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "prePortPlanner",
                      disabled: _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "sealine",
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      "default-value": _vm.form.prePortPlanner || "",
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.prePortPlannerChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.lastMilePlanner &&
          _vm.elementDict.lastMilePlanner.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "lastMilePlanner" }, slot: "lastMilePlanner" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.lastMilePlanner.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.lastMilePlanner.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "lastMilePlanner",
                      disabled: _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "sealine",
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      "default-value": _vm.form.lastMilePlanner || "",
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.lastMilePlannerChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.prePortPlannerDepartment &&
          _vm.elementDict.prePortPlannerDepartment.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "prePortPlannerDepartment" },
                  slot: "prePortPlannerDepartment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.prePortPlannerDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.prePortPlannerDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "prePortPlannerDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.form.prePortPlannerOffice),
                      enables: true,
                      "department-id": Number(_vm.form.prePortPlannerDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.prePortPlannerDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.lastMilePlannerDepartment &&
          _vm.elementDict.lastMilePlannerDepartment.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "lastMilePlannerDepartment" },
                  slot: "lastMilePlannerDepartment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.lastMilePlannerDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.lastMilePlannerDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "lastMilePlannerDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.form.lastMilePlannerOffice),
                      enables: true,
                      "department-id": Number(
                        _vm.form.lastMilePlannerDepartment
                      )
                    },
                    on: {
                      change: function(p) {
                        _vm.form.lastMilePlannerDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.prePortPlannerOffice &&
          _vm.elementDict.prePortPlannerOffice.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "prePortPlannerOffice" },
                  slot: "prePortPlannerOffice"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.prePortPlannerOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.prePortPlannerOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "prePortPlannerOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.form.prePortPlannerOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.prePortPlannerOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.lastMilePlannerOffice &&
          _vm.elementDict.lastMilePlannerOffice.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "lastMilePlannerOffice" },
                  slot: "lastMilePlannerOffice"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.lastMilePlannerOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.lastMilePlannerOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "lastMilePlannerOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.form.lastMilePlannerOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.lastMilePlannerOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.txtWhs.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "txtWhs" }, slot: "txtWhs" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.txtWhs.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.txtWhs.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "txtWhs",
                      disabled: true,
                      type: "textarea",
                      rows: 4,
                      value: _vm.txtWhs
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.remarks.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "remarks" }, slot: "remarks" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.remarks.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        (_vm.lockJobByPrintHblZb ? false : _vm.readonly) ||
                        !_vm.elementDict.remarks.writable,
                      no: "remarks",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.remarks.label,
                          _vm.form.remarks,
                          function(val) {
                            _vm.form.remarks = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isFba
            ? _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "120px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s("FBA"))
                      ]),
                      !_vm.isEdit
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ServiceChannel")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "serviceChannel",
                                  disabled: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_FbaChannel,
                                  filterable: "",
                                  "method-params": {
                                    shippingType: _vm.fbaJob.shippingType,
                                    active: true
                                  },
                                  clearable: true,
                                  "default-value": _vm.fbaJob.serviceChannel
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.fbaJob.serviceChannel = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ServiceChannel")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { filterable: "", clearable: "" },
                                  on: { change: _vm.changeServiceChannel },
                                  model: {
                                    value: _vm.fbaJob.serviceChannel,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fbaJob,
                                        "serviceChannel",
                                        $$v
                                      )
                                    },
                                    expression: "fbaJob.serviceChannel"
                                  }
                                },
                                _vm._l(_vm.channel4JobSelect, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.channelName,
                                      value: item.channelName
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.EstimatedStorageReadyGoodsTime"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "preWarehousingTime",
                              type: "datetime",
                              clearable: "",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.preWarehousingChangeHandler()
                              }
                            },
                            model: {
                              value: _vm.fbaJob.preWarehousingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "preWarehousingTime", $$v)
                              },
                              expression: "fbaJob.preWarehousingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.ExpectedAmazonWarehouseEntryTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "preAmazonWhTime",
                              disabled: _vm.readonly,
                              type: "date",
                              clearable: "",
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.fbaJob.preAmazonWhTime,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "preAmazonWhTime", $$v)
                              },
                              expression: "fbaJob.preAmazonWhTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Destination")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex", flex: "1" } },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.fbaJob.warehouseCode,
                                  placement: "bottom-end"
                                }
                              },
                              [
                                _c("el-cascader", {
                                  staticStyle: {
                                    width: "91px",
                                    "padding-right": "2px"
                                  },
                                  attrs: {
                                    options: _vm.destinations,
                                    filterable: "",
                                    clearable: true
                                  },
                                  on: {
                                    focus: function($event) {
                                      return _vm.JobUtils.focusWarehouseCode(
                                        _vm.fbaJob
                                      )
                                    },
                                    blur: function($event) {
                                      return _vm.JobUtils.blurWarehouseCode(
                                        _vm.fbaJob
                                      )
                                    },
                                    change: function(p) {
                                      _vm.JobUtils.warehouseCodeHandler(
                                        _vm.fbaJob,
                                        p
                                      )
                                      _vm.changeWarehouseCode
                                    }
                                  },
                                  model: {
                                    value: _vm.fbaJob.warehouseCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.fbaJob, "warehouseCode", $$v)
                                    },
                                    expression: "fbaJob.warehouseCode"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { no: "remoteWarehouse" },
                                model: {
                                  value: _vm.fbaJob.remoteWarehouse,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "remoteWarehouse", $$v)
                                  },
                                  expression: "fbaJob.remoteWarehouse"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.RemoteWarehouse"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Warehouse.DestinationCountry")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: true, no: "country" },
                            model: {
                              value: _vm.fbaJob.country,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "country", $$v)
                              },
                              expression: "fbaJob.country"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ZIP") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true, no: "zipCode" },
                            model: {
                              value: _vm.fbaJob.zipCode,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "zipCode", $$v)
                              },
                              expression: "fbaJob.zipCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.DestinationDeliveryMethod")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "destinationDistribution",
                                filterable: ""
                              },
                              on: { change: _vm.destinationDistributionChange },
                              model: {
                                value: _vm.fbaJob.destinationDistribution,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fbaJob,
                                    "destinationDistribution",
                                    $$v
                                  )
                                },
                                expression: "fbaJob.destinationDistribution"
                              }
                            },
                            _vm._l(
                              _vm.FbaJobConstants
                                .ORDER_DESTINATION_DISTRIBUTION_TYPES,
                              function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }
                            ),
                            1
                          )
                        ],
                        1
                      ),
                      _vm.fbaJob.destinationDistribution &&
                      Number(_vm.fbaJob.destinationDistribution) === 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.CourierCompany")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    no: "expressCompany",
                                    placeholder: "",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.fbaJob.expressCompany,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fbaJob,
                                        "expressCompany",
                                        $$v
                                      )
                                    },
                                    expression: "fbaJob.expressCompany"
                                  }
                                },
                                _vm._l(
                                  _vm.FbaJobConstants.EXPRESS_COMPANYS,
                                  function(item) {
                                    return _c("el-option", {
                                      key: item.code,
                                      attrs: {
                                        label: item.chineseName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.fbaJob.destinationDistribution &&
                      Number(_vm.fbaJob.destinationDistribution) === 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.TrackingNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "expressNo" },
                                model: {
                                  value: _vm.fbaJob.expressNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "expressNo", $$v)
                                  },
                                  expression: "fbaJob.expressNo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.POoriginalNumber") }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "poNumber" },
                            model: {
                              value: _vm.fbaJob.poNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "poNumber", $$v)
                              },
                              expression: "fbaJob.poNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Shipment Id" } },
                        [
                          _c("el-input", {
                            attrs: { no: "shipmentId" },
                            model: {
                              value: _vm.fbaJob.shipmentId,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "shipmentId", $$v)
                              },
                              expression: "fbaJob.shipmentId"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Reference Id" } },
                        [
                          _c("el-input", {
                            attrs: { no: "referenceId" },
                            model: {
                              value: _vm.fbaJob.referenceId,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "referenceId", $$v)
                              },
                              expression: "fbaJob.referenceId"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("FbaJob.ChargingMethod")))]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              attrs: { no: "chargingMethod" },
                              on: { change: _vm.chargingMethodChange },
                              model: {
                                value: _vm.fbaJob.chargingMethod,
                                callback: function($$v) {
                                  _vm.$set(_vm.fbaJob, "chargingMethod", $$v)
                                },
                                expression: "fbaJob.chargingMethod"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v(_vm._s("KG"))
                              ]),
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v(_vm._s("CBM"))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("FbaJob.BubbleCountingRatio") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { no: "bubbleCountingRatio" },
                            on: { change: _vm.bubbleCountingChange },
                            model: {
                              value: _vm.fbaJob.bubbleCountingRatio,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "bubbleCountingRatio", $$v)
                              },
                              expression: "fbaJob.bubbleCountingRatio"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.pbProportion") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex", flex: "1" } },
                            [
                              _c("el-input", {
                                attrs: { no: "bubbleSplittingRatio" },
                                on: { change: _vm.bubbleSplittingRatioChange },
                                model: {
                                  value: _vm.fbaJob.bubbleSplittingRatio,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fbaJob,
                                      "bubbleSplittingRatio",
                                      $$v
                                    )
                                  },
                                  expression: "fbaJob.bubbleSplittingRatio"
                                }
                              }),
                              _vm._v("% ")
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomsDeclarationMethod")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethodPol",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 0 },
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.fbaJob.customsMethodPol
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.customsMethodPol = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ClearanceMethod") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethodPod",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 1 },
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.fbaJob.customsMethodPod
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.customsMethodPod = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.EORIEnterpriseNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "eoriNo" },
                            model: {
                              value: _vm.fbaJob.eoriNo,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "eoriNo", $$v)
                              },
                              expression: "fbaJob.eoriNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.VATTaxNumber") } },
                        [
                          _c("el-input", {
                            attrs: { no: "vatNo" },
                            model: {
                              value: _vm.fbaJob.vatNo,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "vatNo", $$v)
                              },
                              expression: "fbaJob.vatNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.VATRegistrationCountry")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "taxRegisterCountry",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Country,
                              filterable: "",
                              "callback-params": { key: "taxRegisterCountry" },
                              "callback-method-type": "value",
                              "default-value": _vm.fbaJob.taxRegisterCountry
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.taxRegisterCountry = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.VATRegistrationAddress")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "taxRegisterAddress" },
                            model: {
                              value: _vm.fbaJob.taxRegisterAddress,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "taxRegisterAddress", $$v)
                              },
                              expression: "fbaJob.taxRegisterAddress"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.VATCompanyEnglishName")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "taxCompany" },
                            model: {
                              value: _vm.fbaJob.taxCompany,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "taxCompany", $$v)
                              },
                              expression: "fbaJob.taxCompany"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField1.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField1" },
                  slot: "userDefinedField1"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField1.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField1.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        (_vm.lockJobByPrintHblZb ? false : _vm.readonly) ||
                        !_vm.elementDict.userDefinedField1.writable,
                      no: "userDefinedField1",
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField1.label,
                          _vm.form.userDefinedField1,
                          function(val) {
                            _vm.form.userDefinedField1 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.userDefinedField1,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userDefinedField1", $$v)
                      },
                      expression: "form.userDefinedField1"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField2.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField2" },
                  slot: "userDefinedField2"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField2.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField2.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        (_vm.lockJobByPrintHblZb ? false : _vm.readonly) ||
                        !_vm.elementDict.userDefinedField2.writable,
                      no: "userDefinedField2",
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField2.label,
                          _vm.form.userDefinedField2,
                          function(val) {
                            _vm.form.userDefinedField2 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.userDefinedField2,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userDefinedField2", $$v)
                      },
                      expression: "form.userDefinedField2"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField3.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField3" },
                  slot: "userDefinedField3"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField3.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField3.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        (_vm.lockJobByPrintHblZb ? false : _vm.readonly) ||
                        !_vm.elementDict.userDefinedField3.writable,
                      no: "userDefinedField3",
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField3.label,
                          _vm.form.userDefinedField3,
                          function(val) {
                            _vm.form.userDefinedField3 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.userDefinedField3,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userDefinedField3", $$v)
                      },
                      expression: "form.userDefinedField3"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField4.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField4" },
                  slot: "userDefinedField4"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField4.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField4.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        (_vm.lockJobByPrintHblZb ? false : _vm.readonly) ||
                        !_vm.elementDict.userDefinedField4.writable,
                      no: "userDefinedField4",
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField4.label,
                          _vm.form.userDefinedField4,
                          function(val) {
                            _vm.form.userDefinedField4 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.userDefinedField4,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userDefinedField4", $$v)
                      },
                      expression: "form.userDefinedField4"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.exportControlledProduct &&
          _vm.elementDict.exportControlledProduct.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "exportControlledProduct" },
                  slot: "exportControlledProduct"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.exportControlledProduct.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.exportControlledProduct.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        no: "exportControlledProduct",
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.exportControlledProduct.writable,
                        placeholder: _vm.form.exportControlledProduct
                          ? ""
                          : _vm.$t("SeaExport.PleaseSelect"),
                        clearable: true,
                        size: "mini"
                      },
                      model: {
                        value: _vm.form.exportControlledProduct,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "exportControlledProduct", $$v)
                        },
                        expression: "form.exportControlledProduct"
                      }
                    },
                    _vm._l(_vm.EXPORT_CONTROLLED_PRODUCT, function(
                      item,
                      index
                    ) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.taxNature && _vm.elementDict.taxNature.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "taxNature" }, slot: "taxNature" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.taxNature.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.taxNature.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled:
                          (_vm.lockJobByPrintHblZb ? false : _vm.readonly) ||
                          !_vm.elementDict.taxNature.writable,
                        no: "taxNature",
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        size: "mini"
                      },
                      model: {
                        value: _vm.form.taxNature,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "taxNature", $$v)
                        },
                        expression: "form.taxNature"
                      }
                    },
                    _vm._l(_vm.TAX_NATURES, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.rateType && _vm.elementDict.rateType.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "rateType" }, slot: "rateType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.rateType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.rateType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled:
                          _vm.readonly || !_vm.elementDict.rateType.writable,
                        no: "rateType",
                        clearable: "",
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        size: "mini"
                      },
                      model: {
                        value: _vm.form.rateType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "rateType", $$v)
                        },
                        expression: "form.rateType"
                      }
                    },
                    _vm._l(_vm.rateType, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.shipper.viewable
            ? _c(
                "div",
                { attrs: { slot: "codeSearching" }, slot: "codeSearching" },
                [
                  !_vm.isFba
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            no: "CodeSearching",
                            disabled: _vm.readonly,
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            no: "FbaCodeSearching",
                            disabled: _vm.readonly,
                            type: "primary"
                          },
                          on: { click: _vm.fbaCodeSearchBtn }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.shipper.viewable,
                  expression: "elementDict.shipper.viewable"
                }
              ],
              staticStyle: { "margin-right": "10px" },
              attrs: {
                slot: "shipper",
                "label-width": "50px",
                "label-position": "left"
              },
              slot: "shipper"
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.shipper.isRequire ? "blue" : "",
                        attrs: { label: _vm.elementDict.shipper.label }
                      }),
                      _c("char-count", {
                        staticStyle: {
                          position: "static",
                          display: "block",
                          "font-size": "10px",
                          color: "#909399"
                        },
                        attrs: { form: _vm.form, prefix: "shipper" }
                      })
                    ],
                    1
                  ),
                  _c("cargo-input", {
                    class: _vm.importDifferenceField.shipperCode
                      ? "red-border"
                      : "",
                    staticStyle: { width: "115px", "margin-right": "5px" },
                    attrs: {
                      no: "shipperCode",
                      placeholder: _vm.readonly
                        ? ""
                        : _vm.$t("SeaExport.ShipperId"),
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify,
                      disabled:
                        _vm.readonly || !_vm.elementDict.shipper.writable
                    },
                    model: {
                      value: _vm.form.shipperCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "shipperCode", $$v)
                      },
                      expression: "form.shipperCode"
                    }
                  }),
                  _c("cargo-company-select", {
                    class: _vm.importDifferenceField.shipperId
                      ? "red-border"
                      : "",
                    staticStyle: { display: "inline-block", width: "145px" },
                    attrs: {
                      no: "shipperId",
                      disabled:
                        _vm.readonly || !_vm.elementDict.shipper.writable,
                      "method-params": { shipper: true, active: true },
                      "default-value": _vm.form.shipperId || ""
                    },
                    on: {
                      change: function(data) {
                        _vm.pm.shipperChange(data)
                      }
                    }
                  })
                ],
                2
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c(
                      "special-character-tip",
                      {
                        attrs: {
                          texts: _vm.specialCharCheck["shipperLine" + i]
                        }
                      },
                      [
                        _c("cargo-input", {
                          ref: "shipperLine" + i,
                          refInFor: true,
                          class: _vm.importDifferenceField["shipperLine" + i]
                            ? "red-border"
                            : "",
                          attrs: {
                            "use-read-only": true,
                            disabled:
                              _vm.readonly || !_vm.elementDict.shipper.writable,
                            no: "shipperLine" + i,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.form,
                                "shipperLine" + i,
                                i + 1 > 6 ? null : "shipperLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.mergeShipperLine(),
                                _vm.splitShipperLine,
                                _vm.notUppercaseShipperConsigneNotify,
                                {
                                  autoHalfWord: true,
                                  autoUppercase:
                                    _vm.notUppercaseShipperConsigneNotify
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form["shipperLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shipperLine" + i, $$v)
                            },
                            expression: "form['shipperLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.consignee.viewable,
                  expression: "elementDict.consignee.viewable"
                }
              ],
              staticStyle: { "margin-right": "20px" },
              attrs: {
                slot: "consignee",
                "label-width": "65px",
                "label-position": "left"
              },
              slot: "consignee"
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.consignee.isRequire
                          ? "blue"
                          : "",
                        attrs: { label: _vm.elementDict.consignee.label }
                      }),
                      _c("char-count", {
                        staticStyle: {
                          position: "static",
                          display: "block",
                          "font-size": "10px",
                          color: "#909399"
                        },
                        attrs: { form: _vm.form, prefix: "consignee" }
                      })
                    ],
                    1
                  ),
                  _c("cargo-input", {
                    class: _vm.importDifferenceField.consigneeCode
                      ? "red-border"
                      : "",
                    staticStyle: { width: "115px", "margin-right": "5px" },
                    attrs: {
                      no: "consigneeCode",
                      placeholder: _vm.readonly
                        ? ""
                        : _vm.$t("SeaExport.ConsigneeId"),
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify,
                      disabled:
                        _vm.readonly || !_vm.elementDict.consignee.writable
                    },
                    model: {
                      value: _vm.form.consigneeCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "consigneeCode", $$v)
                      },
                      expression: "form.consigneeCode"
                    }
                  }),
                  _c("cargo-company-select", {
                    class: _vm.importDifferenceField.consigneeId
                      ? "red-border"
                      : "",
                    staticStyle: { display: "inline-block", width: "145px" },
                    attrs: {
                      no: "consigneeId",
                      disabled:
                        _vm.readonly || !_vm.elementDict.consignee.writable,
                      "method-params": { consignee: true, active: true },
                      "default-value": _vm.form.consigneeId || ""
                    },
                    on: {
                      change: function(data) {
                        _vm.pm.consigneeChange(data)
                      }
                    }
                  })
                ],
                2
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c(
                      "special-character-tip",
                      {
                        attrs: {
                          texts: _vm.specialCharCheck["consigneeLine" + i]
                        }
                      },
                      [
                        _c("cargo-input", {
                          ref: "consigneeLine" + i,
                          refInFor: true,
                          class: _vm.importDifferenceField["consigneeLine" + i]
                            ? "red-border"
                            : "",
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.consignee.writable,
                            no: "consigneeLine" + i,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify,
                            "use-read-only": true
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.form,
                                "consigneeLine" + i,
                                i + 1 > 6 ? null : "consigneeLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Consignee"),
                                _vm.mergeConsigneeLine(),
                                _vm.splitConsigneeLine,
                                _vm.notUppercaseShipperConsigneNotify,
                                {
                                  autoHalfWord: true,
                                  autoUppercase:
                                    _vm.notUppercaseShipperConsigneNotify
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form["consigneeLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.form, "consigneeLine" + i, $$v)
                            },
                            expression: "form['consigneeLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.notify.viewable,
                  expression: "elementDict.notify.viewable"
                }
              ],
              staticStyle: { "margin-right": "20px" },
              attrs: {
                slot: "notify",
                "label-width": "50px",
                "label-position": "left"
              },
              slot: "notify"
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.notify.isRequire ? "blue" : "",
                        attrs: { label: _vm.elementDict.notify.label }
                      }),
                      _c("char-count", {
                        staticStyle: {
                          position: "static",
                          display: "block",
                          "font-size": "10px",
                          color: "#909399"
                        },
                        attrs: { form: _vm.form, prefix: "notify" }
                      })
                    ],
                    1
                  ),
                  _c("cargo-input", {
                    class: _vm.importDifferenceField.notifyCode
                      ? "red-border"
                      : "",
                    staticStyle: { width: "115px", "margin-right": "5px" },
                    attrs: {
                      no: "notifyCode",
                      placeholder: _vm.readonly
                        ? ""
                        : _vm.$t("SeaExport.NotifyId"),
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify,
                      disabled: _vm.readonly || !_vm.elementDict.notify.writable
                    },
                    model: {
                      value: _vm.form.notifyCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "notifyCode", $$v)
                      },
                      expression: "form.notifyCode"
                    }
                  }),
                  _c("cargo-company-select", {
                    class: _vm.importDifferenceField.notifyId
                      ? "red-border"
                      : "",
                    staticStyle: { display: "inline-block", width: "145px" },
                    attrs: {
                      no: "notifyId",
                      disabled:
                        _vm.readonly || !_vm.elementDict.notify.writable,
                      "method-params": { notify: true, active: true },
                      "default-value": _vm.form.notifyId || ""
                    },
                    on: {
                      change: function(data) {
                        _vm.pm.notifyChange(data)
                      }
                    }
                  })
                ],
                2
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c(
                      "special-character-tip",
                      {
                        attrs: { texts: _vm.specialCharCheck["notifyLine" + i] }
                      },
                      [
                        _c("cargo-input", {
                          ref: "notifyLine" + i,
                          refInFor: true,
                          class: _vm.importDifferenceField["notifyLine" + i]
                            ? "red-border"
                            : "",
                          attrs: {
                            disabled:
                              _vm.readonly || !_vm.elementDict.notify.writable,
                            no: "notifyLine" + i,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify,
                            "use-read-only": true
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.form,
                                "notifyLine" + i,
                                i + 1 > 6 ? null : "notifyLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.NotifyParty"),
                                _vm.mergeNotifyLine(),
                                _vm.splitNotifyLine,
                                _vm.notUppercaseShipperConsigneNotify,
                                {
                                  autoHalfWord: true,
                                  autoUppercase:
                                    _vm.notUppercaseShipperConsigneNotify
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form["notifyLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.form, "notifyLine" + i, $$v)
                            },
                            expression: "form['notifyLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          ),
          _vm.elementDict.alsoNotify.viewable
            ? _c(
                "div",
                { attrs: { slot: "alsoNotify" }, slot: "alsoNotify" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.alsoNotify.isRequire ? "blue" : "",
                    staticStyle: {
                      display: "inline-block",
                      "line-height": "28px",
                      "padding-bottom": "5px"
                    },
                    attrs: { label: _vm.elementDict.alsoNotify.label }
                  }),
                  _c("br"),
                  _c("cargo-textarea", {
                    class: _vm.importDifferenceField.alsoNotify
                      ? "also-notify red-border"
                      : "also-notify",
                    attrs: {
                      no: "alsoNotify",
                      disabled:
                        _vm.readonly || !_vm.elementDict.alsoNotify.writable,
                      type: "textarea",
                      "wrap-symbol": "r"
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.SecondNotifyParty"),
                          _vm.form.alsoNotify,
                          function(val) {
                            _vm.form.alsoNotify = val
                          },
                          _vm.notUppercaseShipperConsigneNotify,
                          {
                            warningCount: 45,
                            maxChar: 0,
                            autoHalfWord: true,
                            autoUppercase: _vm.notUppercaseShipperConsigneNotify
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.alsoNotify,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "alsoNotify", $$v)
                      },
                      expression: "form.alsoNotify"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.loadingAgentId &&
          _vm.elementDict.loadingAgentId.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "loadingAgentId" }, slot: "loadingAgentId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.loadingAgentId.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.loadingAgentId.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    attrs: {
                      no: "loadingAgentId",
                      "method-params": { localAgent: true, active: true },
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.loadingAgentId.writable,
                      "default-value": _vm.form.loadingAgentId || "",
                      "data-filter-function": _vm.JobUtils.loadingAgentIdFilter,
                      "tag-name": _vm.isZh ? "chineseName" : "englishName"
                    },
                    on: {
                      change: function(p) {
                        _vm.form.loadingAgentId = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "ContactPerson",
            visible: _vm.contactDialog.visible,
            title: _vm.$t("SeaExport.ContactPerson"),
            width: "400px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.contactDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "right", "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContactPerson") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.contactPerson
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Role") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.role
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Tel") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.telephone
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Mobile") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.mobile
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Fax") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: { disabled: true, value: _vm.contactDialog.data.fax }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Email") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.email
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.remarks,
                      type: "textarea",
                      rows: 3
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "advanceTextDialogConfirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                      _vm.closeAdvanceText()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("sop-dialog", {
        attrs: {
          visible: _vm.sopDialog.visible,
          "cmp-idx": _vm.sopDialog.cmpIdx,
          job: _vm.form,
          agent: _vm.sopDialog.agent,
          lob: "SE",
          "contact-list": _vm.sopDialog.contactList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopDialog, "visible", $event)
          },
          updateJob: function($event) {
            return _vm.$emit("updateJob")
          }
        }
      }),
      _c("transcribe-dialog", {
        attrs: { visible: _vm.transcribeDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.transcribeDialog, "visible", $event)
          },
          callback: _vm.transcribeCallback
        }
      }),
      _c("hs-code-search-dialog", {
        attrs: {
          visible: _vm.hsCodeSearchDialog.visible,
          title: _vm.hsCodeSearchDialog.title
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.hsCodeSearchDialog, "visible", $event)
          },
          callback: _vm.hsCodeSearchDialog.successCallback
        }
      }),
      _c("select-operation-req-dialog", {
        attrs: {
          visible: _vm.selectOperationReqDialog.visible,
          lob: "SE",
          value: _vm.selectOperationReqDialog.value
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectOperationReqDialog, "visible", $event)
          },
          callback: function(val) {
            return (_vm.form.operationContent = val)
          }
        }
      }),
      _c("select-surcharge-terms-dialog", {
        attrs: {
          visible: _vm.selectSurchargeTermsDialog.visible,
          "job-uuid": _vm.form.uuid,
          "row-data": _vm.selectSurchargeTermsDialog.rowData,
          disabled: _vm.readonly
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectSurchargeTermsDialog, "visible", $event)
          },
          callback: _vm.handleSurchargeTerms
        }
      }),
      _c("bill-address-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("fba-bill-address-dialog", {
        attrs: { visible: _vm.fbaBillAddressDialog.visible, job: _vm.fbaJob },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fbaBillAddressDialog, "visible", $event)
          },
          callback: _vm.fbaCodeSearchCallback
        }
      }),
      _c("stamp-picture-view", {
        attrs: {
          visible: _vm.stampPictureView.visible,
          "business-documents": _vm.stampPictureView.businessDocuments
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.stampPictureView, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }